var qvSlider;
(window.theme = window.theme || {}), (window.theme = window.theme || {
}), (theme.Sections = function() {
  (this.constructors = {}), (this.instances = []), $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
}), (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(t, p) {
    var v = $(t),
      y = v.attr("data-section-id"),
      C = v.attr("data-section-type");
    if (((p = p || this.constructors[C]), !_.isUndefined(p))) {
      var k = _.assignIn(new p(t), { id: y, type: C, container: t });
      this.instances.push(k);
    }
  },
  _onSectionLoad: function(t) {
    var p = $("[data-section-id]", t.target)[0];
    p && this._createInstance(p);
  },
  _onSectionUnload: function(t) {
    this.instances = _.filter(this.instances, function(p) {
      var v = p.id === t.detail.sectionId;
      return v && _.isFunction(p.onUnload) && p.onUnload(t), !v;
    });
  },
  _onSelect: function(t) {
    var p = _.find(this.instances, function(v) {
      return v.id === t.detail.sectionId;
    });
    !_.isUndefined(p) && _.isFunction(p.onSelect) && p.onSelect(t);
  },
  _onDeselect: function(t) {
    var p = _.find(this.instances, function(v) {
      return v.id === t.detail.sectionId;
    });
    !_.isUndefined(p) && _.isFunction(p.onDeselect) && p.onDeselect(t);
  },
  _onBlockSelect: function(t) {
    var p = _.find(this.instances, function(v) {
      return v.id === t.detail.sectionId;
    });
    !_.isUndefined(p) && _.isFunction(p.onBlockSelect) && p.onBlockSelect(t);
  },
  _onBlockDeselect: function(t) {
    var p = _.find(this.instances, function(v) {
      return v.id === t.detail.sectionId;
    });
    !_.isUndefined(p) &&
      _.isFunction(p.onBlockDeselect) &&
      p.onBlockDeselect(t);
  },
  register: function(t, p) {
    (this.constructors[t] = p), $("[data-section-type=" + t + "]").each(
      function(v, y) {
        this._createInstance(y, p);
      }.bind(this)
    );
  }
})), (window.slate = window.slate || {}), (slate.rte = {
  wrapTable: function() {
    $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
  },
  iframeReset: function() {
    var t = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    ),
      p = t.add(".rte iframe#admin_bar_iframe");
    t.each(function() {
      $(this).wrap('<div class="video-wrapper"></div>');
    }), p.each(function() {
      this.src = this.src;
    });
  }
}), (window.slate = window.slate || {}), (slate.a11y = {
  pageLinkFocus: function(t) {
    var v = "js-focus-hidden";
    t
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(v)
      .one("blur", function() {
        t.first().removeClass(v).removeAttr("tabindex");
      });
  },
  focusHash: function() {
    var t = window.location.hash;
    t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t));
  },
  bindInPageLinks: function() {
    $("a[href*=#]").on(
      "click",
      function(t) {
        this.pageLinkFocus($(t.currentTarget.hash));
      }.bind(this)
    );
  },
  trapFocus: function(t) {
    var p = t.namespace ? "focusin." + t.namespace : "focusin";
    t.$elementToFocus || (t.$elementToFocus = t.$container), t.$container.attr(
      "tabindex",
      "-1"
    ), t.$elementToFocus.focus(), $(document).off("focusin"), $(
      document
    ).on(p, function(v) {
      t.$container[0] === v.target ||
        t.$container.has(v.target).length ||
        t.$container.focus();
    });
  },
  removeTrapFocus: function(t) {
    var p = t.namespace ? "focusin." + t.namespace : "focusin";
    t.$container &&
      t.$container.length &&
      t.$container.removeAttr("tabindex"), $(document).off(p);
  }
}), (theme.Images = (function() {
  return {
    preload: function(x, S) {
      "string" == typeof x && (x = [x]);
      for (var T, I = 0; I < x.length; I++)
        (T = x[I]), this.loadImage(this.getSizedImageUrl(T, S));
    },
    loadImage: function(x) {
      new Image().src = x;
    },
    switchImage: function(x, S, I) {
      var T = this.imageSize(S.src), P = this.getSizedImageUrl(x.src, T);
      I ? I(P, x, S) : (S.src = P);
    },
    imageSize: function(x) {
      var S = x.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );
      return null === S ? null : S[1];
    },
    getSizedImageUrl: function(x, S) {
      if (null == S) return x;
      if ("master" === S) return this.removeProtocol(x);
      var I = x.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (null != I) {
        var T = x.split(I[0]), P = I[0];
        return this.removeProtocol(T[0] + "_" + S + P);
      }
      return null;
    },
    removeProtocol: function(x) {
      return x.replace(/http(s)?:/, "");
    }
  };
})()), (theme.Currency = (function() {
  return {
    formatMoney: function(v, y) {
      function C(I, T, P, O) {
        if (
          ((T = T || 2), (P = P || ","), (O = O || "."), isNaN(I) || null == I)
        )
          return 0;
        I = (I / 100).toFixed(T);
        var A = I.split("."),
          z = A[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + P),
          E = A[1] ? O + A[1] : "";
        return z + E;
      }
      "string" == typeof v && (v = v.replace(".", ""));
      var k = "", x = /\{\{\s*(\w+)\s*\}\}/, S = y || "${{amount}}";
      switch (S.match(x)[1]) {
        case "amount":
          k = C(v, 2);
          break;
        case "amount_no_decimals":
          k = C(v, 0);
          break;
        case "amount_with_comma_separator":
          k = C(v, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          k = C(v, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          k = C(v, 0, " ");
      }
      return S.replace(x, k);
    }
  };
})()), (slate.Variants = (function() {
  function t(p) {
    (this.$container = p.$container), (this.product =
      p.product), (this.singleOptionSelector =
      p.singleOptionSelector), (this.originalSelectorId =
      p.originalSelectorId), (this.enableHistoryState =
      p.enableHistoryState), (this.currentVariant = this._getVariantFromOptions()), $(
      this.singleOptionSelector,
      this.$container
    ).on("change", this._onSelectChange.bind(this));
  }
  return (t.prototype = _.assignIn({}, t.prototype, {
    _getCurrentOptions: function() {
      var p = _.map($(this.singleOptionSelector, this.$container), function(v) {
        var y = $(v), C = y.attr("type"), k = {};
        return "radio" === C || "checkbox" === C
          ? !!y[0].checked &&
              ((k.value = y.val()), (k.index = y.data("index")), k)
          : ((k.value = y.val()), (k.index = y.data("index")), k);
      });
      return (p = _.compact(p)), p;
    },
    _getVariantFromOptions: function() {
      var p = this._getCurrentOptions(),
        v = this.product.variants,
        y = _.find(v, function(C) {
          return p.every(function(k) {
            return _.isEqual(C[k.index], k.value);
          });
        });
      return y;
    },
    _onSelectChange: function() {
      var p = this._getVariantFromOptions();
      this.$container.trigger({ type: "variantChange", variant: p }), p &&
        (this._updateMasterSelect(p), this._updateImages(p), this._updatePrice(
          p
        ), this._updateSKU(p), (this.currentVariant = p), this
          .enableHistoryState && this._updateHistoryState(p));
    },
    _updateImages: function(p) {
      var v = p.featured_image || {},
        y = this.currentVariant.featured_image || {};
      p.featured_image &&
        v.src !== y.src &&
        this.$container.trigger({ type: "variantImageChange", variant: p });
    },
    _updatePrice: function(p) {
      (p.price === this.currentVariant.price &&
        p.compare_at_price === this.currentVariant.compare_at_price) ||
        this.$container.trigger({ type: "variantPriceChange", variant: p });
    },
    _updateSKU: function(p) {
      p.sku === this.currentVariant.sku ||
        this.$container.trigger({ type: "variantSKUChange", variant: p });
    },
    _updateHistoryState: function(p) {
      if (history.replaceState && p) {
        var v =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          p.id;
        window.history.replaceState({ path: v }, "", v);
      }
    },
    _updateMasterSelect: function(p) {
      $(this.originalSelectorId, this.$container).val(p.id);
    }
  })), t;
})()), (theme.Drawers = (function() {
  function t(p, v, y) {
    return (this.nodes = {
      $parent: $("html").add("body"),
      $page: $("#PageContainer")
    }), (this.config = $.extend(
      {
        close: ".js-drawer-close",
        open: ".js-drawer-open-" + v,
        openClass: "js-drawer-open",
        dirOpenClass: "js-drawer-open-" + v
      },
      y
    )), (this.position = v), (this.$drawer = $("#" + p)), !!this.$drawer
      .length && void ((this.drawerIsOpen = !1), this.init());
  }
  return (t.prototype.init = function() {
    $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on(
      "click",
      this.config.close,
      $.proxy(this.close, this)
    );
  }), (t.prototype.open = function(p) {
    var v = !1;
    return (p ? p.preventDefault() : (v = !0), p &&
      p.stopPropagation &&
      (p.stopPropagation(), (this.$activeSource = $(p.currentTarget))), this
      .drawerIsOpen && !v)
      ? this.close()
      : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(
          this.config.openClass + " " + this.config.dirOpenClass
        ), (this.drawerIsOpen = !0), slate.a11y.trapFocus({
          $container: this.$drawer,
          namespace: "drawer_focus"
        }), this.config.onDrawerOpen &&
          "function" == typeof this.config.onDrawerOpen &&
          !v &&
          this.config.onDrawerOpen(), this.$activeSource &&
          this.$activeSource.attr("aria-expanded") &&
          this.$activeSource.attr(
            "aria-expanded",
            "true"
          ), this.bindEvents(), this);
  }), (t.prototype.close = function() {
    this.drawerIsOpen &&
      ($(document.activeElement).trigger(
        "blur"
      ), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(
        this.config.dirOpenClass + " " + this.config.openClass
      ), (this.drawerIsOpen = !1), slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: "drawer_focus"
      }), this.unbindEvents());
  }), (t.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function(p) {
        return 27 !== p.keyCode || (this.close(), !1);
      }, this)
    ), this.nodes.$page.on("touchmove.drawer", function() {
      return !1;
    }), this.nodes.$page.on(
      "click.drawer",
      $.proxy(function() {
        return this.close(), !1;
      }, this)
    );
  }), (t.prototype.unbindEvents = function() {
    this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
  }), t;
})()), (window.theme = window.theme || {}), (theme.Header = (function() {
  function t() {
    $(C.navigationTarget).html(""), $(C.navigationSource)
      .detach()
      .appendTo(C.navigationTarget);
  }
  function p() {
    $(C.navigation).mmenu({ offCanvas: !1, navbar: { title: !1 } }), $(
      C.navigationTrigger
    ).on("click", function(k) {
      k.preventDefault();
      trapFocus("#mm-0");
      var x = $(".mm-listview > li");
      x.velocity("transition.slideLeftIn", {
        delay: 500,
        duration: 300,
        stagger: 100
      });
    });
  }
  function v() {
    if ("true" == $(C.header).attr("data-my-sticky")) {
      function L() {
        (F = q.height()), (E = z.height()), (D = z.scrollTop()), (V =
          B - D), T.toggleClass("header--narrow", D > S), $(
          document.body
        ).toggleClass("sticky-header-show", D > S), D <= A
          ? T.removeClass(k)
          : 0 < V && T.hasClass(k)
              ? T.removeClass(k)
              : 0 > V &&
                  (D + E >= F && T.hasClass(k)
                    ? T.removeClass(k)
                    : T.addClass(k)), (B = D);
      }
      var k = "header--hidden", S = 20, T = $(C.header);
      if (!T.length) return !0;
      "false" == $(C.header).attr("data-my-sticky-scroll") &&
        (k = ""), "true" == $(C.header).attr("data-my-sticky-mobile") &&
        $(C.header).addClass("mobile");
      var P = $("#topbar"),
        O = $("#masthead"),
        A = P.length ? P.outerHeight() : 0;
      (A += O.length ? O.outerHeight() : 0), (S += A);
      var z = $(window),
        E = 0,
        D = 0,
        B = 0,
        V = 0,
        q = $(document),
        F = 0,
        U = function(H, M) {
          var W, R;
          return function() {
            var Q = this, N = arguments, K = +new Date();
            W && K < W + H
              ? (clearTimeout(R), (R = setTimeout(function() {
                  (W = K), M.apply(Q, N);
                }, H)))
              : ((W = K), M.apply(Q, N));
          };
        };
      z.on(
        "scroll",
        U(50, function() {
          L();
        })
      ), L();
    }
  }
  var C = {
    header: ".site-header",
    navigation: "nav#menu",
    navigationTrigger: ".site-header .menu-trigger",
    navigationSource: ".site-header .menu-offcanvas",
    navigationTarget: ".offcanvas_aside_left #menu-offcanvas"
  };
  return {
    init: function() {
      $(C.navigation).length && (t(), p(), v());
    }
  };
})()), (window.theme = window.theme || {}), (theme.Search = (function() {
  function t() {
    $(y.searchTarget).html(""), $(y.search).detach().appendTo(y.searchTarget);
  }
  function p() {
    function C() {
      var O = T.val();
      if (2 > O.length)
        return S.removeClass(
          "searching found-products found-no-product"
        ).addClass("invalid-length"), void S.find(
          ".search_suggestion"
        ).slideDown();
      var A = "/search?" + I.serialize();
      if (
        (S.find(".search_suggestion").slideUp(function() {
          S.removeClass("found-products found-no-product").addClass(
            "searching"
          );
        }), O in x)
      ) {
        var z = x[O];
        S.removeClass("searching"), z.found
          ? (S.addClass("found-products"), P.find(
              ".search_result .suggestion_unlisted"
            ).html(z.products), P.find(
              ".search_result .suggestion_more a"
            ).attr("href", A), P.find(
              ".search_result .suggestion_unlisted, .search_result .suggestion_more"
            ).slideDown(function() {
              S.removeClass("invalid-length");
            }))
          : (S.addClass("found-no-product"), P.find(
              ".search_result .suggestion_unlisted"
            ).html(
              $('<div class="not-found text-center" />').text(z.text)
            ), P.find(".search_result .suggestion_more a").attr(
              "href",
              "#"
            ), P.find(".search_result .suggestion_more").slideUp(), P.find(
              ".search_result .suggestion_unlisted"
            ).slideDown(function() {
              S.removeClass("invalid-length");
            })), S.addClass("searched");
      } else
        k = $.get(
          A,
          function(E) {
            var D = $(E),
              B = D.find("#content-position .products"),
              V = D.find("#content-position .no-products .empty");
            S.removeClass("searching"), B.length
              ? (B.children(".last").nextAll().remove(), S.addClass(
                  "found-products"
                ), P.find(".search_result .suggestion_unlisted").html(
                  B
                ), P.find(".search_result .suggestion_more a").attr(
                  "href",
                  A
                ), P.find(
                  ".search_result .suggestion_unlisted, .search_result .suggestion_more"
                ).slideDown(function() {
                  S.removeClass("invalid-length");
                }), (x[O] = { found: !0, products: B }))
              : V.length &&
                  (S.addClass("found-no-product"), P.find(
                    ".search_result .suggestion_unlisted"
                  ).html(
                    $('<div class="not-found text-center" />').text(V.text())
                  ), P.find(".search_result .suggestion_more a").attr(
                    "href",
                    "#"
                  ), P.find(
                    ".search_result .suggestion_more"
                  ).slideUp(), P.find(
                    ".search_result .suggestion_unlisted"
                  ).slideDown(function() {
                    S.removeClass("invalid-length");
                  }), (x[O] = {
                    found: !1,
                    text: V.text()
                  })), theme.CurrencyPicker.convert(
              ".search_result .products .product .money"
            ), S.addClass("searched");
          },
          "html"
        );
    }
    var k = null,
      x = {},
      S = $("#search-offcanvas"),
      I = S.find("form"),
      T = I.find("input.search-field"),
      P = S.find(".suggestion_results");
    S.on("keyup", ".search-field", function(O) {
      var A = !1;
      "undefined" == typeof O.which
        ? (A = !0)
        : "number" == typeof O.which &&
            0 < O.which &&
            (A = !O.ctrlKey && !O.metaKey && !O.altKey);
      A && (k && (k.abort(), T.focus()), C());
    }).on("focusout", ".search-field", function() {
      2 > T.val().length &&
        P.find(
          ".search_result .suggestion_unlisted, .buttons"
        ).slideUp(function() {
          S.removeClass(
            "searching searched found-products found-no-product invalid-length"
          );
        });
    });
  }
  var y = {
    search: "#search-section",
    searchTarget: ".offcanvas_aside_right .offcanvas_search"
  };
  return {
    init: function() {
      $(y.search).length && (t(), p());
    }
  };
})()), (window.theme = window.theme || {
}), (theme.CurrencyPicker = (function() {
  function t() {
    var k = $(y.currency).closest(".language_currency");
    (C.currency_format = k
      .find(".currency_format")
      .val()), (C.shop_currency = k
      .find(".shop_currency")
      .val()), (C.default_currency = k
      .find(".default_currency")
      .val()), (C.money_with_currency_format = k
      .find(".money_with_currency_format")
      .val()), (C.money_format = k
      .find(".money_format")
      .val()), (Currency.format = C.currency_format);
    var x = C.shop_currency;
    (Currency.moneyFormats[x].money_with_currency_format =
      C.money_with_currency_format), (Currency.moneyFormats[x].money_format =
      C.money_format);
    var S = C.default_currency;
    try {
      var I = Currency.cookie.read();
      $("span.money span.money").each(function() {
        $(this).parents("span.money").removeClass("money");
      }), $("span.money").each(function() {
        $(this).attr("data-currency-" + C.shop_currency, $(this).html());
      }), null == I
        ? x === S ? (Currency.currentCurrency = S) : Currency.convertAll(x, S)
        : $(y.currency).length &&
            0 === $(y.currency + " .currency[data-code=" + I + "]").size()
            ? ((Currency.currentCurrency = x), Currency.cookie.write(x))
            : I === x
                ? (Currency.currentCurrency = x)
                : Currency.convertAll(x, I), $(
        y.currency
      ).on("click", ".currency:not(.active)", function() {
        var O = $(this).attr("data-code");
        Currency.convertAll(
          Currency.currentCurrency,
          O
        ), $(y.currencyPicker).removeClass("active"), $(this).addClass("active");
      });
      var T = window.selectCallback;
      $("body").on("ajaxCart.afterCartLoad", function() {
        Currency.convertAll(
          x,
          $(y.currencyActive).attr("data-code")
        ), $(y.currencyPicker).removeClass("active"), $(y.currency + " .currency[data-code=" + Currency.currentCurrency + "]").addClass("active");
      }), $(y.currencyPicker).removeClass("active"), $(
        y.currency + " .currency[data-code=" + Currency.currentCurrency + "]"
      ).addClass("active");
    } catch (O) {
      console.log(O.message);
    }
  }
  var y = {
    currency: ".language_currency .currency_switcher",
    currencyPicker: ".language_currency .currency_switcher .currency",
    currencyActive: ".language_currency .currency_switcher .currency.active"
  },
    C = {
      currency_format: "",
      shop_currency: "",
      default_currency: "",
      money_with_currency_format: "",
      money_format: ""
    };
  return {
    init: function() {
      $(y.currency).length && t();
    },
    convert: function(k) {
      if ($(y.currency).length)
        try {
          $(k).each(function() {
            $(this).attr("data-currency-" + C.shop_currency, $(this).html());
          }), Currency.convertAll(
            C.shop_currency,
            Currency.cookie.read(),
            k,
            C.currency_format
          );
        } catch (x) {
          console.log(x.message);
        }
    }
  };
})()), (function() {
  function t(y) {
    var C = document.createElement("a");
    return (C.ref = y), C.hostname;
  }
  var v = $({ backButton: ".return-link" }.backButton);
  document.referrer &&
    v.length &&
    window.history.length &&
    v.one("click", function(y) {
      y.preventDefault();
      var C = t(document.referrer), k = t(window.location.href);
      return k === C && history.back(), !1;
    });
})(), (theme.Slideshow = (function() {
  function t(S) {
    (this.$slideshow = $(S)), (this.$wrapper = this.$slideshow.closest(
      "." + x.wrapper
    )), (this.$pause = this.$wrapper.find(
      "." + x.pauseButton
    )), (this.settings = {
      accessibility: !0,
      arrows: !0,
      dots: !1,
      fade: !0,
      draggable: !0,
      touchThreshold: 20,
      autoplay: this.$slideshow.data("autoplay"),
      autoplaySpeed: this.$slideshow.data("speed")
    }), this.$slideshow.on("beforeChange", y.bind(this)), this.$slideshow.on(
      "init",
      v.bind(this)
    ), this.$slideshow.slick(this.settings), this.$pause.on(
      "click",
      this.togglePause.bind(this)
    ), p();
  }
  function p() {
    $("." + x.imageBackground).bgLoaded({
      afterLoaded: function() {
        $("." + x.wrapper).removeClass("loading").addClass("loaded"), $(
          "." + x.wrapper
        )
          .find(".tp-loader")
          .hide();
      }
    });
  }
  function v(S, I) {
    var T = I.$slider,
      P = I.$list,
      O = this.$wrapper,
      A = this.settings.autoplay;
    P.removeAttr("aria-live"), O.on("focusin", function(z) {
      O.has(z.target).length &&
        (P.attr("aria-live", "polite"), A && T.slick("slickPause"));
    }), O.on("focusout", function(z) {
      if (O.has(z.target).length && (P.removeAttr("aria-live"), A)) {
        if ($(z.target).hasClass(x.closeVideoBtn)) return;
        T.slick("slickPlay");
      }
    }), I.$dots &&
      I.$dots.on("keydown", function(z) {
        37 === z.which &&
          T.slick(
            "slickPrev"
          ), 39 === z.which && T.slick("slickNext"), (37 === z.which || 39 === z.which) && I.$dots.find(".slick-active button").focus();
      });
  }
  function y(S, I, T, P) {
    var O = I.$slider,
      A = O.find("." + x.currentSlide),
      z = O.find('.slideshow__slide[data-slick-index="' + P + '"]');
    if (C(A)) {
      var E = A.find("." + x.video), D = E.attr("id");
      theme.SlideshowVideo.pauseVideo(D), E.attr("tabindex", "-1");
    }
    if (C(z)) {
      var B = z.find("." + x.video),
        V = B.attr("id"),
        q = B.hasClass(x.videoBackground);
      q ? theme.SlideshowVideo.playVideo(V) : B.attr("tabindex", "0");
    }
  }
  function C(S) {
    return S.find("." + x.video).length;
  }
  function k(S) {
    return "#Slideshow-" + S.data("id");
  }
  this.$slideshow = null;
  var x = {
    wrapper: "slideshow-wrapper",
    slideshow: "slideshow",
    imageBackground: "slideshow__image",
    currentSlide: "slick-current",
    video: "slideshow__video",
    videoBackground: "slideshow__video--background",
    closeVideoBtn: "slideshow__video-control--close",
    pauseButton: "slideshow__pause",
    isPaused: "is-paused"
  };
  return (t.prototype.togglePause = function() {
    var S = k(this.$pause);
    this.$pause.hasClass(x.isPaused)
      ? (this.$pause.removeClass(x.isPaused), $(S).slick("slickPlay"))
      : (this.$pause.addClass(x.isPaused), $(S).slick("slickPause"));
  }), t;
})());
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}
(theme.SlideshowVideo = (function() {
  function k(X, ee) {
    var te = G[X], ae = Z[X], se = G[X].$parentSlide;
    if (N) z(te);
    else if (ee || (W && R))
      return se.removeClass(J.loading), z(te), void ae.playVideo();
    W || S(ae, se);
  }
  function x(X) {
    var ee = X ? J.supportsAutoplay : J.supportsNoAutoplay;
    $(document.documentElement).addClass(ee), X || (N = !0), (W = !0);
  }
  function S(X, ee) {
    X.playVideo(), I(X)
      .then(function() {
        x(!0);
      })
      .fail(function() {
        x(!1), X.stopVideo();
      })
      .always(function() {
        (W = !0), ee.removeClass(J.loading);
      });
  }
  function I(X) {
    var te, ae, ee = $.Deferred();
    return (te = setInterval(function() {
      0 >= X.getCurrentTime() ||
        ((R = !0), clearInterval(te), clearTimeout(ae), ee.resolve());
    }, 500)), (ae = setTimeout(function() {
      clearInterval(te), ee.reject();
    }, 4e3)), ee;
  }
  function T() {
    Q ||
      (750 > $(window).width()
        ? (N = !0)
        : window.mobileCheck() && (N = !0), N && x(!1), (Q = !0));
  }
  function A(X) {
    switch (X.type) {
      case "background":
        Z[X.id].seekTo(0);
        break;
      case "background-chrome":
        Z[X.id].seekTo(0), D(X.id);
        break;
      case "chrome":
        D(X.id);
    }
  }
  function z(X) {
    var ee = X.$parentSlideshowWrapper, te = X.$parentSlide;
    if ((te.removeClass(J.loading), "background" !== X.status)) {
      switch (($("#" + X.id).attr("tabindex", "0"), X.type)) {
        case "chrome":
        case "background-chrome":
          ee.removeClass(J.paused).addClass(J.playing), te
            .removeClass(J.paused)
            .addClass(J.playing);
      }
      te.find("." + J.closeVideoBtn).focus();
    }
  }
  function E(X) {
    var ee = X.$parentSlideshowWrapper, te = X.$parentSlide;
    return "background-chrome" === X.type
      ? void D(X.id)
      : void ("closed" !== X.status &&
          "background" !== X.type &&
          (ee.addClass(J.paused), te.addClass(J.paused)), "chrome" === X.type &&
          "closed" === X.status &&
          (ee.removeClass(J.paused), te.removeClass(J.paused)), ee.removeClass(
          J.playing
        ), te.removeClass(J.playing));
  }
  function D(X) {
    var ee = G[X],
      te = ee.$parentSlideshowWrapper,
      ae = ee.$parentSlide,
      se = [J.pause, J.playing].join(" ");
    switch (($("#" + ee.id).attr("tabindex", "-1"), (ee.status =
      "closed"), ee.type)) {
      case "background-chrome":
        Z[X].mute(), L(X);
        break;
      case "chrome":
        Z[X].stopVideo(), E(ee);
    }
    te.removeClass(se), ae.removeClass(se);
  }
  function B(X) {
    return G[X.target.h.id];
  }
  function V(X) {
    var ee = G[X];
    switch ((ee.$parentSlide.addClass(J.loading), (ee.status =
      "open"), ee.type)) {
      case "background-chrome":
        U(X, ee), Z[X].unMute(), k(X, !0);
        break;
      case "chrome":
        k(X, !0);
    }
    $(document).on("keydown.videoPlayer", function(te) {
      27 === te.keyCode && D(X);
    });
  }
  function q() {
    $("." + J.videoBackground).each(function(X, ee) {
      F($(ee));
    });
  }
  function F(X) {
    var ee = X.closest("." + J.slide);
    if (!ee.hasClass(J.slickClone)) {
      var te = ee.width(), ae = X.width(), se = X.height();
      te / Y.ratio < se
        ? ((ae = Math.ceil(se * Y.ratio)), X.width(ae)
            .height(se)
            .css({ left: (te - ae) / 2, top: 0 }))
        : ((se = Math.ceil(te / Y.ratio)), X.width(te)
            .height(se)
            .css({
              left: 0,
              top: (se - se) / 2
            })), X.prepareTransition().addClass(J.loaded);
    }
  }
  function U(X) {
    $("#" + X)
      .removeAttr("style")
      .removeClass(J.videoBackground)
      .addClass(J.videoChrome), G[X].$parentSlideshowWrapper
      .removeClass(J.slideBackgroundVideo)
      .addClass(J.playing), G[X].$parentSlide
      .removeClass(J.slideBackgroundVideo)
      .addClass(J.playing), (G[X].status = "open");
  }
  function L(X) {
    var ee = $("#" + X).addClass(J.videoBackground).removeClass(J.videoChrome);
    G[X].$parentSlide.addClass(J.slideBackgroundVideo), (G[X].status =
      "background"), F(ee);
  }
  function H() {
    $(document).on("click.videoPlayer", "." + J.playVideoBtn, function(X) {
      var ee = $(X.currentTarget).data("controls");
      V(ee);
    }), $(document).on("click.videoPlayer", "." + J.closeVideoBtn, function(X) {
      var ee = $(X.currentTarget).data("controls");
      D(ee);
    }), $(window).on(
      "resize.videoPlayer",
      $.debounce(250, function() {
        K && q();
      })
    );
  }
  var W = !1,
    R = !1,
    Q = !1,
    N = !1,
    K = !1,
    G = {},
    Z = [],
    Y = {
      ratio: 16 / 9,
      playerVars: {
        iv_load_policy: 3,
        modestbranding: 1,
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        wmode: "opaque",
        branding: 0,
        autohide: 0,
        rel: 0
      },
      events: {
        onReady: function(X) {
          X.target.setPlaybackQuality("hd1080");
          var ee = B(X);
          switch ((T(), $("#" + ee.id).attr("tabindex", "-1"), q(), ee.type)) {
            case "background-chrome":
            case "background":
              X.target.mute(), ee.$parentSlide.hasClass(J.currentSlide) &&
                k(ee.id);
          }
          ee.$parentSlide.addClass(J.loaded);
        },
        onStateChange: function(X) {
          var ee = B(X);
          switch (X.data) {
            case 0:
              A(ee);
              break;
            case 1:
              z(ee);
              break;
            case 2:
              E(ee);
          }
        }
      }
    },
    J = {
      playing: "video-is-playing",
      paused: "video-is-paused",
      loading: "video-is-loading",
      loaded: "video-is-loaded",
      slideshowWrapper: "slideshow-wrapper",
      slide: "slideshow__slide",
      slideBackgroundVideo: "slideshow__slide--background-video",
      slideDots: "slick-dots",
      videoChrome: "slideshow__video--chrome",
      videoBackground: "slideshow__video--background",
      playVideoBtn: "slideshow__video-control--play",
      closeVideoBtn: "slideshow__video-control--close",
      currentSlide: "slick-current",
      slickClone: "slick-cloned",
      supportsAutoplay: "autoplay",
      supportsNoAutoplay: "no-autoplay"
    };
  return {
    init: function(X) {
      if (
        X.length &&
        ((G[X.attr("id")] = {
          id: X.attr("id"),
          videoId: X.data("id"),
          type: X.data("type"),
          status: "chrome" === X.data("type") ? "closed" : "background",
          videoSelector: X.attr("id"),
          $parentSlide: X.closest("." + J.slide),
          $parentSlideshowWrapper: X.closest("." + J.slideshowWrapper),
          controls: "background" === X.data("type") ? 0 : 1,
          slideshow: X.data("slideshow")
        }), !K)
      ) {
        var ee = document.createElement("script");
        ee.src = "https://www.youtube.com/iframe_api";
        var te = document.getElementsByTagName("script")[0];
        te.parentNode.insertBefore(ee, te);
      }
    },
    loadVideos: function() {
      for (var X in G)
        if (G.hasOwnProperty(X)) {
          var ee = $.extend({}, Y, G[X]);
          (ee.playerVars.controls = ee.controls), (Z[X] = new YT.Player(X, ee));
        }
      H(), (K = !0);
    },
    loadVideo: function(X) {
      if (K) {
        var ee = $.extend({}, Y, G[X]);
        (ee.playerVars.controls = ee.controls), (Z[X] = new YT.Player(
          X,
          ee
        )), H();
      }
    },
    playVideo: function(X) {
      (Q || N) && (!X || "function" != typeof Z[X].playVideo || k(X));
    },
    pauseVideo: function(X) {
      Z[X] && "function" == typeof Z[X].pauseVideo && Z[X].pauseVideo();
    },
    removeEvents: function() {
      $(document).off(".videoPlayer"), $(window).off(".videoPlayer");
    }
  };
})()), (function() {
  var t = $("#BlogTagFilter");
  t.length &&
    t.on("change", function() {
      location.href = $(this).val();
    });
})(), (window.theme = theme || {}), (theme.customerTemplates = (function() {
  function t() {
    $("#RecoverPassword").on("click", function(k) {
      k.preventDefault(), p();
    }), $("#HideRecoverPasswordLink").on("click", function(k) {
      k.preventDefault(), p();
    });
  }
  function p() {
    $("#RecoverPasswordForm").toggleClass("hide"), $(
      "#CustomerLoginForm"
    ).toggleClass("hide");
  }
  function v() {
    var k = $(".reset-password-success");
    k.length && $("#ResetSuccess").removeClass("hide");
  }
  function y() {
    var k = $("#AddressNewForm");
    k.length &&
      (Shopify &&
        new Shopify.CountryProvinceSelector(
          "AddressCountryNew",
          "AddressProvinceNew",
          { hideElement: "AddressProvinceContainerNew" }
        ), $(".address-country-option").each(function() {
        var x = $(this).data("form-id");
        new Shopify.CountryProvinceSelector(
          "AddressCountry_" + x,
          "AddressProvince_" + x,
          { hideElement: "AddressProvinceContainer_" + x }
        );
      }), $(".address-new-toggle").on("click", function() {
        k.toggleClass("hide");
      }), $(".address-edit-toggle").on("click", function() {
        var x = $(this).data("form-id");
        $("#EditAddress_" + x).toggleClass("hide");
      }), $(".address-delete").on("click", function() {
        var x = $(this), S = x.data("form-id"), I = x.data("confirm-message");
        confirm(I || "Are you sure you wish to delete this address?") &&
          Shopify.postLink("/account/addresses/" + S, {
            parameters: { _method: "delete" }
          });
      }));
  }
  function C() {
    var k = window.location.hash;
    "#recover" === k && p();
  }
  return {
    init: function() {
      C(), t(), v(), y();
    }
  };
})()), (window.theme = window.theme || {}), (theme.Filters = (function() {
  function t() {
    $(y.filter).length &&
      ($(y.fiterTarget).html(""), $(y.filter)
        .clone()
        .appendTo(y.fiterTarget), $(".offcanvas_shop_sidebar").fitVids());
  }
  function p(C) {
    this.$container = $(C);
    t(), $(document).on(
      "change",
      y.sortSelection,
      this._onSortChange.bind(this)
    ), $(document).on(
      "change",
      y.filterSelection,
      this._onFilterChange.bind(this)
    ), $(document).on("click", y.filterClear, this._onFilterClear.bind(this));
  }
  var y = {
    sortSelection: ".filters-toolbar__input--sort",
    defaultSort: ".collection-header__default-sort",
    filter: ".shop-page #secondary",
    fiterTarget: ".offcanvas_aside_left .offcanvas_shop_sidebar .widget-area",
    filterSelection: ".advanced-filter .filter",
    filterClear: ".widget_filter .clear"
  };
  return (p.prototype = _.assignIn({}, p.prototype, {
    _filterAjaxClick: function(C) {
      delete Shopify.queryParams.page;
      var k = this._filterCreateUrl(C);
      this._filterGetContent(k);
    },
    _filterCreateUrl: function(C) {
      var k = $.param(Shopify.queryParams).replace(/%2B/g, "+");
      return C ? "" == k ? C : C + "?" + k : location.pathname + "?" + k;
    },
    _filterGetContent: function(C) {
      var k = "#content-position", x = ".shop_sidebar #secondary", I = this;
      $.ajax({
        type: "get",
        url: C,
        beforeSend: function() {
          $("body").addClass("loading");
        },
        success: function(T) {
          var P = $(T).filter("title").text();
          $(k).empty().html($(T).find(k).html()), $(x)
            .empty()
            .html($(T).find(x).html()), $(".offcanvas_shop_sidebar #secondary")
            .empty()
            .html($(T).find(x).html()), History.pushState(
            { param: Shopify.queryParams },
            P,
            C
          ), setTimeout(function() {
            $("html,body").animate(
              { scrollTop: $("body .site-content").offset().top },
              500,
              "swing"
            );
          }, 100), $("body").removeClass("loading"), I._mapReviews();
        },
        error: function() {
          $("body").removeClass("loading");
        }
      });
    },
    _mapReviews: function() {
      "undefined" != typeof SPR &&
        (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
    },
    _onFilterClear: function(C) {
      var k = [];
      Shopify.queryParams.constraint &&
        (k = Shopify.queryParams.constraint.split("+"));
      var x = $(C.currentTarget),
        S = x.closest(".widget_filter").find("select");
      0 < S.length &&
        S.find("option").each(function() {
          var T = $(this).val();
          if (T) {
            var P = k.indexOf(T);
            0 <= P && k.splice(P, 1);
          }
        });
      var I = x.closest(".widget_filter").find("input");
      0 < I.length &&
        I.each(function() {
          var T = $(this).val();
          if (T) {
            var P = k.indexOf(T);
            0 <= P && k.splice(P, 1);
          }
        }), k.length
        ? (Shopify.queryParams.constraint = k.join("+"))
        : delete Shopify.queryParams.constraint, this._filterAjaxClick();
    },
    _onSortChange: function(C) {
      var k = $(C.currentTarget),
        x = $(y.defaultSort, this.$container).val(),
        S = k.val() ? k.val() : x;
      (Shopify.queryParams.sort_by = S), this._filterAjaxClick();
    },
    _onFilterChange: function(C) {
      var k = $(C.currentTarget),
        x = k.closest(".advanced-filter").attr("data-multi_choice"),
        S = [];
      if (
        (Shopify.queryParams.constraint &&
          (S = Shopify.queryParams.constraint.split("+")), "false" == x &&
          !k.closest(".filter-tag").hasClass("active"))
      ) {
        var I = k.closest(".advanced-filter").find(".active input");
        0 < I.length &&
          I.each(function() {
            var A = $(this).val();
            if (A) {
              var z = S.indexOf(A);
              0 <= z && S.splice(z, 1);
            }
          });
      }
      var T = k.closest(".advanced-filter").find("select");
      0 < T.length &&
        T.find("option").each(function() {
          var A = $(this).val();
          if (A) {
            var z = S.indexOf(A);
            0 <= z && S.splice(z, 1);
          }
        });
      var P = k.val();
      if (P) {
        var O = S.indexOf(P);
        0 <= O ? S.splice(O, 1) : S.push(P);
      }
      S.length
        ? (Shopify.queryParams.constraint = S.join("+"))
        : delete Shopify.queryParams.constraint, this._filterAjaxClick();
    },
    onUnload: function() {
      this.$sortSelect.off(
        "change",
        this._onSortChange
      ), this.$filterSelect.off(
        "change",
        this._onFilterChange
      ), this.$filterClear.off("click", this._onFilterClear);
    }
  })), p;
})()), (window.theme = window.theme || {}), (theme.HeaderSection = (function() {
  return function() {
    theme.Header.init(), theme.Search.init(), theme.CurrencyPicker.init();
  };
})()), (theme.MegaMenu = (function() {
  function t() {
    this.initMegaMenu();
  }
  
  return (t.prototype = _.assignIn({}, t.prototype, {
    initMegaMenu: function() {
      if ($("#menu-primary-mega-menu").length) {
        var p = $("#menu-primary-mega-menu .list-item").html();
        $(".site-header .list-item").html(p), $("#menu .offcanvas_menu")
          .find(".menu-item")
          .remove(), $("#menu .offcanvas_menu").prepend(p);
      }
    }
  })), t;
})()), (theme.Maps = (function() {
  function t(S) {
    (this.$container = $(S)), "loaded" === C
      ? this.createMap()
      : (k.push(this), "loading" != C &&
          ((C = "loading"), "undefined" == typeof window.google &&
            $.getScript(
              "https://maps.googleapis.com/maps/api/js?key=" + x
            ).then(function() {
              (C = "loaded"), p();
            })));
  }
  function p() {
    $.each(k, function(S, I) {
      I.createMap();
    });
  }
  function v(S) {
    var I = $.Deferred(),
      T = new google.maps.Geocoder(),
      P = S.data("address-setting");
    return T.geocode({ address: P }, function(O, A) {
      A !== google.maps.GeocoderStatus.OK && I.reject(A), I.resolve(O);
    }), I;
  }
  var y = { zoom: 14 }, C = null, k = [], x = theme.mapKey ? theme.mapKey : "";
  return (t.prototype = _.assignIn({}, t.prototype, {
    createMap: function() {
      var S = this.$container.find(".map-section__container");
      return v(S)
        .then(
          function(I) {
            var T = {
              zoom: y.zoom,
              center: I[0].geometry.location,
              disableDefaultUI: !0
            },
              P = (this.map = new google.maps.Map(S[0], T)),
              O = (this.center = P.getCenter()),
              A = new google.maps.Marker({ map: P, position: P.getCenter() });
            google.maps.event.addDomListener(
              window,
              "resize",
              $.debounce(250, function() {
                google.maps.event.trigger(P, "resize"), P.setCenter(O);
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var I;
          (I = "ZERO_RESULTS" === status
            ? theme.strings.addressNoResults
            : "OVER_QUERY_LIMIT" === status
                ? theme.strings.addressQueryLimit
                : theme.strings
                    .addressError), S.parent().addClass("page-width map-section--load-error").html('<div class="errors text-center">' + I + "</div>");
        });
    },
    onUnload: function() {
      google.maps.event.clearListeners(this.map, "resize");
    }
  })), t;
})());
function gm_authFailure() {
  $(".map-section").addClass("map-section--load-error"), $(
    ".map-section__container"
  ).remove(), $(".map-section__link").remove(), $(
    ".map-section__overlay"
  ).after(
    '<div class="errors text-center">' + theme.strings.authError + "</div>"
  );
}
(theme.Product = (function() {
  function t(p) {
    var v = (this.$container = $(p)),
      y = (this.sectionId = v.attr("data-section-id"));
    (this.settings = {
      mediaQueryMediumUp: "screen and (min-width: 750px)",
      mediaQuerySmall: "screen and (max-width: 749px)",
      bpSmall: !1,
      enableHistoryState: v.data("enable-history-state") || !1,
      imageSize: null,
      namespace: ".slideshow-" + y,
      sectionId: y,
      sliderActive: !1,
      swatch_color: v.attr("data-product_swatch_color"),
      swatch_size: v.attr("data-product_swatch_size")
    }), (this.selectors = {
      product: "#ProductSection-" + y,
      addToCart: "#AddToCart-" + y,
      addToCartText: "#AddToCartText-" + y,
      stockText: ".stock-" + y,
      comparePrice: "#ComparePrice-" + y,
      originalPrice: "#ProductPrice-" + y,
      SKU: ".variant-sku",
      originalPriceWrapper: ".product-price__price-" + y,
      originalSelectorId: "#ProductSelect-" + y,
      productFeaturedImage: ".FeaturedImage-" + y,
      productImageWrap: "#FeaturedImageZoom-" + y,
      productQuickViewFeaturedImage: ".QuickViewFeaturedImage-" + y,
      productCarouselWrap: "#CarouselImages-" + y,
      productPrices: ".product-single__price-" + y,
      productThumbImages: "#product_thumbnails_swiper_container-" + y,
      productMainImages: "#product-images-carousel-" + y,
      productQuickViewMainImages: "#product-quickview-images-carousel-" + y,
      productUpsells: "#product-upsells-" + y,
      saleLabel: ".product-price__sale-label-" + y,
      singleOptionSelector: ".single-option-selector-" + y,
      singleOptionSelectorId: "#single-option-selector-" + y,
      singleOptionSwatches: "tawcvs-swatches-" + y,
      countDownId: ".countdown-" + y,
      threedId: ".threed-id-" + y
    }), $("#ProductJson-" + y).html() &&
      ((this.productSingleObject = JSON.parse(
        document.getElementById("ProductJson-" + y).innerHTML
      )), this._initCountDown(), this._initReadMore(), this._initFeature(), this._stringOverrides(), this._initVariants(), this._initSwatches(), this._initImages(), this._initImagesScroll(), this._initImagesCarousel(), this._initGallery(), this._initTab(), this._socialSharing(), this._initInstagram(), this._relatedProducts(), this._stickUpSells(), this._upsellProducts());
  }
  return (t.prototype = _.assignIn({}, t.prototype, {
    _stringOverrides: function() {
      (theme.productStrings = theme.productStrings || {}), $.extend(
        theme.strings,
        theme.productStrings
      );
    },
    _initFeature: function() {
      if (
        (0 < $(this.selectors.product + " .product-video-button a").length &&
          $(this.selectors.product + " .product-video-button a").magnificPopup({
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: !1,
            disableOn: !1,
            fixedContentPos: !1
          }), 0 < $(this.selectors.product + " .product-360-button a").length)
      ) {
        for (
          var C,
            p = [],
            v = JSON.parse(
              document.getElementById("threed-id-" + this.sectionId).innerHTML
            ),
            y = 1;
          72 >= y;
          y++
        )
          (C = "f" + y), v[C] && p.push(v[C]);
        if (0 < p.length) {
          var k = p.length;
          $(this.selectors.threedId).ThreeSixty({
            totalFrames: k,
            endFrame: k,
            currentFrame: 1,
            imgList: ".threed-view-images",
            progress: ".spinner",
            imgArray: p,
            height: null,
            width: null,
            responsive: !0,
            navigation: !0,
            onReady: function() {
              $(".product-360-button a").magnificPopup({
                type: "inline",
                mainClass: "mfp-fade",
                removalDelay: 160,
                disableOn: !1,
                preloader: !1,
                fixedContentPos: !1,
                callbacks: {
                  open: function() {
                    $(window).resize();
                  }
                }
              });
            }
          });
        }
      }
    },
    _initCountDown: function() {
      if (
        !(0 >= $(this.selectors.countDownId).length) &&
        $().countdown &&
        0 < $(this.selectors.countDownId).length
      ) {
        var p = new Date(),
          v = $(this.selectors.countDownId).data("countdown").split("-"),
          v = new Date(v[2], parseInt(v[0]) - 1, v[1]);
        p < v &&
          $(this.selectors.countDownId).countdown({
            until: v,
            layout: "<div><i>{dn}</i><span>{dl}</span></div><div><i>{hn}</i><span>{hl}</span></div><div><i>{mn}</i><span>{ml}</span></div><div><i>{sn}</i><span>{sl}</span></div>"
          });
      }
    },
    _initReadMore: function(){
      $(".template-product .viewmore_desc").length > 0 && $(".template-product .viewmore_desc").on("click", function(){
        $("html,body").animate(
          { scrollTop: ($("body #tab-description").offset().top - 75) },
          500,
          "swing"
        );
      })
    },
    _initBreakpoints: function() {
      this;
      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {},
        unmatch: function() {}
      }), enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {}
      });
    },
    _stickUpSells: function() {
      var p = $("#topbar"),
        v = $("#masthead"),
        y = $(this.selectors.productUpsells);
      if (y.length) {
        var C = $("#primary"), k = p.length ? p.outerHeight() : 0;
        (k += v.length ? v.outerHeight() : 0), $(window)
          .on("scroll", function() {
            if (
              ($(document).scrollTop() >= k
                ? (y.addClass("sticky"), !y.data("wrap") &&
                    (y.wrap(
                      '<div id="upsells-wrap" class="upsells-wrap"/>'
                    ), y.data("wrap", !0)))
                : (y.removeClass("sticky"), y.data("wrap") &&
                    (y.unwrap(), y.data("wrap", !1))), $(window).scrollTop() >=
                C.offset().top + C.outerHeight() - window.innerHeight)
            ) {
              var x = $("#upsells-wrap");
              x.addClass("sticky-bottom").css("top", function() {
                return $(window).scrollTop() - C.offset().top;
              }), x.outerHeight() <= y.outerHeight()
                ? x.addClass("reach-bottom")
                : x.removeClass("reach-bottom");
            } else $("#upsells-wrap").removeClass("sticky-bottom").css("top", 0);
          })
          .trigger("scroll");
      }
    },
    _upsellProducts: function() {
      var p = $(this.selectors.productUpsells);
      !p.length ||
        (4 < p.find(".product").length &&
          p
            .find(".products")
            .addClass("owl-carousel")
            .owlCarousel({
              dots: !0,
              nav: !0,
              navText: ["", ""],
              items: 2,
              responsive: {
                0: { items: 1 },
                992: { items: 1 },
                1200: { items: 2 }
              }
            }));
    },
    _relatedProducts: function() {
      var p = $(
        this.selectors.product +
          " .single_product_summary_related .products-carousel .products"
      );
      if (p.length) {
        var v = p.attr("data-per-view");
        p.owlCarousel({
          items: v,
          margin: 30,
          lazyLoad: !0,
          dots: !0,
          responsiveClass: !0,
          nav: !0,
          mouseDrag: !0,
          navText: ["", ""],
          responsive: {
            0: { margin: 20, items: 2, nav: !1 },
            600: { margin: 25, items: 3, nav: !1 },
            1e3: { items: 4, nav: !0, dots: !1 },
            1200: { items: v, nav: !0, dots: !1 }
          }
        });
      }
    },
    _initTab: function() {
      $(this.selectors.product + " .product-tabs")
        .off("click")
        .on("click", "ul.tabs li a", function(p) {
          if ((p.preventDefault(), $(this).parent("li").hasClass("active")))
            return !1;
          var v = $(this),
            y = v.closest(".product-tabs"),
            C = y.find("ul.tabs");
          return C.find("li").removeClass(
            "active"
          ), $(this).parent("li").addClass("active"), y.find(".panel:visible").fadeOut(300, function() {
            y.find(v.attr("href")).fadeIn(300);
          }), !1;
        });
    },
    _socialSharing: function() {
      var p = $(this.selectors.product + " .box-share-master-container").attr(
        "data-share-elem"
      );
      $(this.selectors.product + " .social-sharing").socialShare({
        social: p,
        animation: "launchpadReverse",
        blur: !0
      });
    },
    _initInstagram: function() {
      if (0 < $("#product-instagram").length) {
        var p = $("#product-instagram"),
          v = p.attr("data-id"),
          y = p.attr("data-token"),
          C = p.attr("data-limit"),
          k = new Instafeed({
            get: "user",
            target: "product-instagram",
            accessToken: y,
            userId: parseInt(v),
            limit: parseInt(C),
            resolution: "thumbnail",
            resolution2: "thumbnail",
            template: '<li><a target="_blank" href="{{link}}"><img src="{{image}}" alt="{{caption}}" /></a></li>',
            after: function() {
             
            }
          });
        k.run();
      }
    },
    _initGallery: function() {
      (function(v) {
        function y(z, E) {
          return -1 < (" " + z.className + " ").indexOf(" " + E + " ");
        }
        for (
          var C = function(z) {
            for (
              var V,
                q,
                F,
                U,
                E = $(z).find(".photoswipe-item").get(),
                D = E.length,
                B = [],
                L = 0;
              L < D;
              L++
            )
              ((V = E[L]), 1 === V.nodeType) &&
                ((q = V.children[0]), (F = q
                  .getAttribute("data-size")
                  .split("x")), (U = "video" == $(q).data("type")
                  ? { html: $(q).data("video") }
                  : {
                      src: q.getAttribute("href"),
                      w: parseInt(F[0], 10),
                      h: parseInt(F[1], 10)
                    }), 1 < V.children.length &&
                  (U.title = $(V).find(".caption").html()), 0 <
                  q.children.length &&
                  (U.msrc = q.children[0].getAttribute(
                    "src"
                  )), (U.el = V), B.push(U));
            return B;
          },
            k = function z(E, D) {
              return E && (D(E) ? E : z(E.parentNode, D));
            },
            x = function(z) {
              (z = z || window.event), z.preventDefault
                ? z.preventDefault()
                : (z.returnValue = !1);
              var E = z.target || z.srcElement,
                D = k(E, function(H) {
                  return y(H, "photoswipe-item");
                });
              if (D) {
                for (
                  var U,
                    B = D.closest(".photoswipe-wrapper"),
                    V = $(D.closest(".photoswipe-wrapper"))
                      .find(".photoswipe-item")
                      .get(),
                    q = V.length,
                    F = 0,
                    L = 0;
                  L < q;
                  L++
                )
                  if (1 === V[L].nodeType) {
                    if (V[L] === D) {
                      U = F;
                      break;
                    }
                    F++;
                  }
                return 0 <= U && I(U, B), !1;
              }
            },
            S = function() {
              var z = window.location.hash.substring(1), E = {};
              if (5 > z.length) return E;
              for (var D = z.split("&"), B = 0; B < D.length; B++)
                if (D[B]) {
                  var V = D[B].split("=");
                  2 > V.length || (E[V[0]] = V[1]);
                }
              return E.gid && (E.gid = parseInt(E.gid, 10)), E;
            },
            I = function(z, E, D, B) {
              var q, F, U, V = document.querySelectorAll(".pswp")[0];
              if (
                ((U = C(E)), (F = {
                  closeOnScroll: !1,
                  galleryUID: E.getAttribute("data-pswp-uid"),
                  getThumbBoundsFn: function(H) {
                    var M = U[H].el.getElementsByTagName("img")[0],
                      W =
                        window.pageYOffset ||
                        document.documentElement.scrollTop,
                      R = M.getBoundingClientRect();
                    return { x: R.left, y: R.top + W, w: R.width };
                  }
                }), !B)
              )
                F.index = parseInt(z, 10);
              else if (F.galleryPIDs) {
                for (var L = 0; L < U.length; L++)
                  if (U[L].pid == z) {
                    F.index = L;
                    break;
                  }
              } else F.index = parseInt(z, 10) - 1;
              isNaN(F.index) ||
                (D && (F.showAnimationDuration = 0), (q = new PhotoSwipe(
                  V,
                  PhotoSwipeUI_Default,
                  U,
                  F
                )), q.init(), q.listen("beforeChange", function() {
                  var H = $(q.currItem.container);
                  $(".pswp__video").removeClass("active");
                  H.find(".pswp__video").addClass("active");
                  $(".pswp__video").each(function() {
                    $(this).hasClass("active") ||
                      $(this).attr("src", $(this).attr("src"));
                  });
                }), q.listen("close", function() {
                  $(".pswp__video").each(function() {
                    $(this).attr("src", $(this).attr("src"));
                  });
                }));
            },
            T = document.querySelectorAll(v),
            P = 0,
            O = T.length;
          P < O;
          P++
        )
          T[P].setAttribute("data-pswp-uid", P + 1), (T[P].onclick = x);
        var A = S();
        A.pid && A.gid && I(A.pid, T[A.gid - 1], !0, !0);
      })(this.selectors.product + " .photoswipe-wrapper");
    },
    _initImagesCarousel: function() {
      if ($(this.selectors.productCarouselWrap).length) {
        var p = $(this.selectors.productCarouselWrap),
          v = 2 < p.children().length ? 1 : 0;
        p.owlCarousel({
          items: 2,
          startPosition: v,
          loop: !1,
          margin: 30,
          center: !0,
          dots: !1,
          nav: !0,
          navText: ["", ""]
        });
      }
    },
    _initImagesScroll: function() {
      if ($(this.selectors.productImageWrap).hasClass("module")) {
        ($.fn.visible = function(v) {
          var y = $(this),
            C = $(window),
            k = C.scrollTop(),
            x = k + C.height(),
            S = y.offset().top,
            I = S + y.height(),
            T = !0 === v ? I : S,
            P = !0 === v ? S : I;
          return P <= x && T >= k;
        }), "false" == $("header.site-header").attr("data-my-sticky") &&
          $(this.selectors.product + " .product_infos").attr(
            "data-margin-top",
            "1"
          ), $(document).foundation();
        var p = $(".module");
        p.each(function(v, y) {
          var y = $(y);
          y.visible(!0) && y.addClass("already-visible");
        }), $(window).scroll(function() {
          1024 < $(window).width() &&
            p.each(function(y, C) {
              var C = $(C);
              C.visible(!0) && C.addClass("come-in");
            });
        });
      }
    },
    _initImages: function() {
      function p(I) {
        !1 != y && y.slideTo(I - 1, 300, !1), $(v.selectors.productThumbImages)
          .find(".swiper-slide")
          .removeClass("active")
          .eq(I)
          .addClass("active");
      }
      var v = this, y = !1;
      if (0 < $(v.selectors.productThumbImages).length)
        var C = $(v.selectors.productThumbImages).attr("data-direction"),
          y = new Swiper(v.selectors.productThumbImages, {
            direction: C,
            slidesPerView: "auto",
            mousewheelControl: !1,
            preventClicks: !1
          });
      $(v.selectors.productMainImages).owlCarousel({
        items: 1,
        lazyLoad: !0,
        animateIn: "fadeIn",
        animateOut: "fadeOut",
        nav: !0,
        dots: !0,
        navText: ["", ""],
        responsive: { 0: { dots: !0, nav: !1 }, 1024: { dots: !1, nav: !0 } }
      });
      var k = $(v.selectors.productMainImages);
      if (
        ($(".product_content_wrapper").each(function() {
          $(v.selectors.productThumbImages)
            .find(".swiper-slide")
            .eq(0)
            .addClass("active"), !1 != y &&
            y.on("onTap", function() {
              p(
                y.clickedIndex
              ), k.trigger("to.owl.carousel", [y.clickedIndex, 300]);
            });
        }), k.on("changed.owl.carousel", function(I) {
          if (jQuery(".product_thumbnails").length) {
            var T = I.item.index;
            !1 != y && y.slideTo(T - 1, 300, !1), $(
              v.selectors.productThumbImages
            )
              .find(".swiper-slide")
              .removeClass("active")
              .eq([T])
              .addClass("active");
          }
        }), !$(".easyzoom").length)
      )
        1024 < $(window).width() &&
          $(".variations").on("change", "select", function() {
            0 < $("#product-images-carousel").length &&
              k.trigger("to.owl.carousel", [0, 300]);
          });
      else if (1024 < $(window).width()) {
        var x = $(".easyzoom").easyZoom({
          loadingNotice: "",
          errorNotice: "",
          preventClicks: !0
        }),
          S = x.data("easyZoom");
        $(".variations").on("change", "select", function() {
          0 < $("#product-images-carousel").length &&
            k.trigger("to.owl.carousel", [0, 300]);
        });
      } else
        $(".easyzoom a").click(function(I) {
          I.preventDefault();
        }), $(".variations").on("change", "select", function() {
          0 < $("#product-images-carousel").length &&
            k.trigger("to.owl.carousel", [0, 300]);
        });
    },
    _initSwatches: function() {
      var p = this.productSingleObject, v = [];
      if (
        ("true" == this.settings.swatch_size && v.push("Size"), "true" ==
          this.settings.swatch_color && (v.push("Color"), v.push("Colour")), 0 <
          v.length)
      ) {
        var y = !1,
          C = !1,
          k = 0,
          x = theme.asset_url.substring(0, theme.asset_url.lastIndexOf("?")),
          S = theme.asset_url.substring(
            theme.asset_url.lastIndexOf("?"),
            theme.asset_url.length
          );
        for (i = 0; i < p.options.length; i++) {
          var I = "", T = "", P = "", O = "", A = "", z = "", E = "";
          if (
            ((I = "object" == typeof p.options[i]
              ? p.options[i].name
              : p.options[i]), (y = !1), (C = !1), -1 < v.indexOf(I))
          ) {
            (y = !0), (k = i);
            var D = I.toLowerCase();
            if ((/color|colour/i.test(D) && (C = !0), y)) {
              var V = [];
              for (j = 0; j < p.variants.length; j++) {
                var q = p.variants[j],
                  F = this._htmlEntities(q.options[k]),
                  U = this._convertToSlug(F),
                  H = "";
                /color|colour/i.test(D) &&
                  (H =
                    ' style="background-color:' +
                    U +
                    ";background-image:url(" +
                    x +
                    U +
                    ".png" +
                    S +
                    ');"'), 0 > V.indexOf(F) &&
                  ((E = "color" != D && "colour" != D
                    ? "swatch-label "
                    : ""), (z = $(
                    this.selectors.singleOptionSelectorId + "-" + k
                  ).val() == F
                    ? "selected "
                    : ""), (P =
                    P +
                    '<span data-id="' +
                    this.selectors.singleOptionSelectorId +
                    "-" +
                    k +
                    '" class="' +
                    z +
                    "swatch " +
                    E +
                    " swatch-" +
                    D +
                    " swatch-" +
                    F +
                    '" data-title="' +
                    F +
                    '" data-value="' +
                    F +
                    '"><span' +
                    H +
                    ">" +
                    F +
                    "</span></span>"), V.push(F));
              }
              (T =
                '<div class="' +
                this.selectors.singleOptionSwatches +
                ' tawcvs-swatches" data-attribute_name="attribute_pa_' +
                D +
                '">' +
                P +
                "</div>"), (O = $(
                this.selectors.singleOptionSelectorId + "-" + k
              )), (A = $(this.selectors.variationSelector + "-" + k)), "" !=
                T &&
                (O.after(T), O.parent().addClass("has-swatch"), A.addClass(
                  "hide-choose-option"
                ));
            }
          }
        }
      }
      var M = "";
      0 < $("." + this.selectors.singleOptionSwatches).length &&
        ((M = $(
          "." + this.selectors.singleOptionSwatches + " > span"
        )), M.unbind("click"), M.on("click", function() {
          var W = $(this).data("id");
          $(this).data("value") != $(W).val() &&
            ($(W).val($(this).data("value")).trigger("change"), $(W)
              .closest(".single-option-selector")
              .find(".swatch")
              .removeClass("selected"), $(this).addClass("selected"));
        }));
    },
    _htmlEntities: function(p) {
      return (p + "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },
    _convertToSlug: function(p) {
      return p
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    _initVariants: function() {
      var p = {
        $container: this.$container,
        enableHistoryState: this.$container.data("enable-history-state") || !1,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };
      (this.variants = new slate.Variants(p)), this.$container.on(
        "variantChange" + this.settings.namespace,
        this._updateAddToCart.bind(this)
      ), this.$container.on(
        "variantImageChange" + this.settings.namespace,
        this._updateImages.bind(this)
      ), this.$container.on(
        "variantPriceChange" + this.settings.namespace,
        this._updatePrice.bind(this)
      ), this.$container.on(
        "variantSKUChange" + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },
    _updateAddToCart: function(p) {
      var v = p.variant;
      v
        ? ($(this.selectors.productPrices)
            .removeClass("invisible")
            .attr("aria-hidden", "true"), v.available
            ? ($(this.selectors.addToCart)
                .prop("disabled", !1)
                .toggleClass("hide", !1), $(this.selectors.addToCartText).text(
                theme.strings.addToCart
              ), $(this.selectors.stockText)
                .text(theme.strings.inStock)
                .removeClass("out-of-stock")
                .addClass("in-stock"), "shopify" == v.inventory_management &&
                "continue" != v.inventory_policy &&
                0 < v.inventory_quantity &&
                $(this.selectors.stockText).text(
                  v.inventory_quantity + " " + theme.strings.inStock
                ))
            : ($(this.selectors.addToCart)
                .prop("disabled", !0)
                .toggleClass("hide", !0), $(this.selectors.addToCartText).text(
                theme.strings.soldOut
              ), $(this.selectors.stockText)
                .text(theme.strings.outStock)
                .removeClass("in-stock")
                .addClass("out-of-stock")))
        : ($(this.selectors.addToCart)
            .prop("disabled", !0)
            .toggleClass("hide", !0), $(this.selectors.addToCartText).text(
            theme.strings.unavailable
          ), $(this.selectors.stockText)
            .text(theme.strings.unavailable)
            .removeClass("in-stock")
            .addClass("out-of-stock"), $(this.selectors.productPrices)
            .addClass("invisible")
            .attr("aria-hidden", "false"));
    },
    _updateImages: function(p) {
      var v = p.variant,
        y = this,
        C = v.featured_image.src
          .replace("https:", "")
          .replace("http:", "")
          .split("?v=")[0];
      $(this.selectors.productFeaturedImage).each(function(k) {
        var x = $(this).attr("href");
        if (0 <= x.indexOf(C)) {
          var S = $(y.selectors.productMainImages);
          return void S.trigger("to.owl.carousel", [k, 300]);
        }
      }), 0 < $(this.selectors.productQuickViewFeaturedImage).length &&
        $(this.selectors.productQuickViewFeaturedImage).each(function(k) {
          var x = $(this).attr("data-href");
          if (0 <= x.indexOf(C)) return void qvSlider.slideTo(k);
        });
    },
    _updatePrice: function(p) {
      var v = p.variant;
      if (
        ($(this.selectors.originalPrice).html(
          '<span class="money">' +
            theme.Currency.formatMoney(v.price, theme.moneyFormat) +
            "</span>"
        ), v.compare_at_price > v.price)
      ) {
        if (
          ($(this.selectors.comparePrice)
            .html(
              '<span class="money">' +
                theme.Currency.formatMoney(
                  v.compare_at_price,
                  theme.moneyFormat
                ) +
                "</span>"
            )
            .removeClass("hide"), $(this.selectors.saleLabel)
            .find("span")
            .text(theme.strings.sale), "" != theme.sale_percentages)
        ) {
          var y = Math.round(
            100 * (v.compare_at_price - v.price) / v.compare_at_price
          );
          $(this.selectors.saleLabel).find("span").text("-" + y + "%");
        }
        $(this.selectors.saleLabel).removeClass("hide");
      } else
        $(this.selectors.comparePrice).addClass("hide"), $(
          this.selectors.saleLabel
        ).addClass("hide");
      theme.CurrencyPicker.convert(this.selectors.product + " .money");
    },
    _updateSKU: function(p) {
      var v = p.variant;
      "" == v.sku
        ? $(this.selectors.SKU).addClass("hide")
        : $(this.selectors.SKU).removeClass("hide").find(".sku").text(v.sku);
    },
    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  })), t;
})()), (theme.Products = (function() {
  function t(p) {
    var v = (this.$container = $(p)), y = v.attr("data-section-id");
    (this.settings = {
      slider: "#products-" + y + " .products-carousel .products"
    }), this._initSlider();
  }
  return (t.prototype = _.assignIn({}, t.prototype, {
    _initSlider: function() {
      if ($(this.settings.slider).length) {
        var p = $(this.settings.slider).attr("data-per-view");
        $(this.settings.slider).owlCarousel({
          items: p,
          margin: 30,
          lazyLoad: !0,
          dots: !1,
          responsiveClass: !0,
          nav: !0,
          mouseDrag: !0,
          navText: ["", ""],
          responsive: {
            0: { margin: 20, items: 2, nav: !1 },
            600: { margin: 25, items: 3, nav: !1 },
            1e3: { items: 4, nav: !0, dots: !1 },
            1200: { items: p, nav: !0, dots: !1 }
          }
        });
      }
    },
    onUnload: function() {
      var p = $(this.settings.slider);
      p
        .trigger("destroy.owl.carousel")
        .removeClass("owl-carousel owl-loaded"), p
        .find(".owl-stage-outer")
        .children()
        .unwrap();
    },
    onBlockSelect: function() {}
  })), t;
})()), (theme.ProductTabs = (function() {
  function t(p) {
    var v = (this.$container = $(p)), y = v.attr("data-section-id");
    (this.settings = {
      slider: "#product-tabs-" + y + " .products-carousel .products",
      tab: "#product-tabs-" + y + " .product-tabs"
    }), this._initTab(), this._initSlider();
  }
  return (t.prototype = _.assignIn({}, t.prototype, {
    _initTab: function() {
      $(this.settings.tab).length &&
        $(this.settings.tab)
          .off("click")
          .on("click", "ul.tabs li a", function(p) {
            if ((p.preventDefault(), $(this).parent("li").hasClass("active")))
              return !1;
            var v = $(this),
              y = v.closest(".product-tabs"),
              C = y.find("ul.tabs");
            return C.find("li").removeClass(
              "active"
            ), $(this).parent("li").addClass("active"), y.find(".panel:visible").fadeOut(300, function() {
              y.find(v.attr("href")).fadeIn(300);
            }), !1;
          });
    },
    _initSlider: function() {
      if ($(this.settings.slider).length) {
        var p = $(this.settings.slider).attr("data-per-view");
        $(this.settings.slider).owlCarousel({
          items: p,
          margin: 30,
          lazyLoad: !0,
          dots: !1,
          responsiveClass: !0,
          nav: !0,
          mouseDrag: !0,
          navText: ["", ""],
          responsive: {
            0: { margin: 20, items: 2, nav: !1 },
            600: { margin: 25, items: 3, nav: !1 },
            1e3: { items: 4, nav: !0, dots: !1 },
            1200: { items: p, nav: !0, dots: !1 }
          }
        });
      }
    },
    onUnload: function() {
      var p = $(this.settings.slider);
      p
        .trigger("destroy.owl.carousel")
        .removeClass("owl-carousel owl-loaded"), p
        .find(".owl-stage-outer")
        .children()
        .unwrap();
    },
    onBlockSelect: function() {}
  })), t;
})()), (theme.Blog = (function() {
  function t(p) {
    var v = (this.$container = $(p)), y = v.attr("data-section-id");
    (this.settings = {
      slider: "#blog-" + y + " .from-the-blog"
    }), this._initSlider();
  }
  return (t.prototype = _.assignIn({}, t.prototype, {
    _initSlider: function() {
      $(this.settings.slider).length &&
        $(this.settings.slider).each(function() {
          var p = $(this);
          p.owlCarousel({
            items: 3,
            dots: !1,
            responsiveClass: !0,
            nav: !0,
            navText: ["", ""],
            responsive: {
              0: { items: 1, nav: !1, dots: !0 },
              600: { items: 2, nav: !1, dots: !0 },
              1e3: { items: 3, nav: !0 },
              1200: { items: 3, nav: !0 }
            }
          });
        });
    },
    onUnload: function() {
      var p = $(this.settings.slider);
      p
        .trigger("destroy.owl.carousel")
        .removeClass("owl-carousel owl-loaded"), p
        .find(".owl-stage-outer")
        .children()
        .unwrap();
    },
    onBlockSelect: function() {}
  })), t;
})()), (theme.Collections = (function() {
  function t(p) {
    var v = (this.$container = $(p)), y = v.attr("data-section-id");
    (this.settings = {
      slider: "#collections-" + y + " .product-category-carousel"
    }), this._initSlider();
  }
  return (t.prototype = _.assignIn({}, t.prototype, {
    _initSlider: function() {
      if ($(this.settings.slider).length) {
        var p = $(this.settings.slider).attr("data-per-view");
        $(this.settings.slider).owlCarousel({
          items: p,
          margin: 30,
          lazyLoad: !0,
          dots: !1,
          responsiveClass: !0,
          nav: !0,
          mouseDrag: !0,
          navText: ["", ""],
          responsive: {
            0: { margin: 20, items: 2, nav: !1 },
            600: { margin: 25, items: 3, nav: !1 },
            1e3: { items: 4, nav: !0, dots: !1 },
            1200: { items: p, nav: !0, dots: !1 }
          }
        });
      }
    },
    onUnload: function() {
      var p = $(this.settings.slider);
      p
        .trigger("destroy.owl.carousel")
        .removeClass("owl-carousel owl-loaded"), p
        .find(".owl-stage-outer")
        .children()
        .unwrap();
    },
    onBlockSelect: function() {}
  })), t;
})()), (theme.slideshows = {}), (theme.SlideshowSection = (function() {
  return function(p) {
    var v = (this.$container = $(p)),
      y = v.attr("data-section-id"),
      C = (this.slideshow = "#Slideshow-" + y);
    $(".slideshow__video", C).each(function() {
      var k = $(this);
      theme.SlideshowVideo.init(
        k
      ), theme.SlideshowVideo.loadVideo(k.attr("id"));
    }), (theme.slideshows[C] = new theme.Slideshow(C));
  };
})()), (theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function(t) {
      var p = $(this.slideshow),
        v = $(".slideshow__slide--" + t.detail.blockId + ":not(.slick-cloned)"),
        y = v.data("slick-index");
      p.slick("slickGoTo", y).slick("slickPause");
    },
    onBlockDeselect: function() {
      $(this.slideshow).slick("slickPlay");
    }
  }
)), (theme.FooterSection = (function() {
  function t(p) {
    var v = (this.$container = $(p)), y = v.attr("data-section-id");
    (this.settings = {
      instagram: "#site-footer-" + y + " #footer-instagram"
    }), this._initInstagram();
  }
  return (t.prototype = _.assignIn({}, t.prototype, {
    _initInstagram: function() {
      if ($(this.settings.instagram).length) {
        var p = $(this.settings.instagram),
          v = p.attr("data-id"),
          y = p.attr("data-token"),
          C = p.attr("data-limit"),
          k = new Instafeed({
            get: "user",
            target: "footer-instagram",
            accessToken: y,
            userId: parseInt(v),
            limit: parseInt(C),
            resolution: "thumbnail",
            resolution2: "thumbnail",
            template: '<li><a target="_blank" href="{{link}}"><img src="{{image}}" alt="{{caption}}" /></a></li>',
            after: function() {
            
            }
          });
        k.run();
      }
    },
    onUnload: function() {},
    onBlockSelect: function() {}
  })), t;
})());
var $special, resizeTimeout, $event = $.event;
$special = $event.special.debouncedresize = {
  setup: function() {
    $(this).on("resize", $special.handler);
  },
  teardown: function() {
    $(this).off("resize", $special.handler);
  },
  handler: function(t, p) {
    var v = this,
      y = arguments,
      C = function() {
        (t.type = "debouncedresize"), $event.dispatch.apply(v, y);
      };
    resizeTimeout && clearTimeout(resizeTimeout), p
      ? C()
      : (resizeTimeout = setTimeout(C, $special.threshold));
  },
  threshold: 250
};
var BLANK =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
($.fn.imagesLoaded = function(t) {
  function p() {
    var P = $(I), O = $(T);
    C && (T.length ? C.reject(x, P, O) : C.resolve(x)), $.isFunction(t) &&
      t.call(y, x, P, O);
  }
  function v(P, O) {
    P.src === BLANK ||
      -1 !== $.inArray(P, S) ||
      (S.push(P), O ? T.push(P) : I.push(P), $.data(P, "imagesLoaded", {
        isBroken: O,
        src: P.src
      }), k && C.notifyWith($(P), [O, x, $(I), $(T)]), x.length === S.length &&
        (setTimeout(p), x.unbind(".imagesLoaded")));
  }
  var y = this,
    C = $.isFunction($.Deferred) ? $.Deferred() : 0,
    k = $.isFunction(C.notify),
    x = y.find("img").add(y.filter("img")),
    S = [],
    I = [],
    T = [];
  return $.isPlainObject(t) &&
    $.each(t, function(P, O) {
      "callback" === P ? (t = O) : C && C[P](O);
    }), x.length
    ? x
        .bind("load.imagesLoaded error.imagesLoaded", function(P) {
          v(P.target, "error" === P.type);
        })
        .each(function(P, O) {
          var A = O.src, z = $.data(O, "imagesLoaded");
          return z && z.src === A
            ? void v(O, z.isBroken)
            : O.complete && void 0 !== O.naturalWidth
                ? void v(O, 0 === O.naturalWidth || 0 === O.naturalHeight)
                : void ((O.readyState || O.complete) &&
                    ((O.src = BLANK), (O.src = A)));
        })
    : p(), C ? C.promise(y) : y;
}), (theme.gridsSection = (function() {
  function t(p) {
    var v = (this.$container = $(p)),
      y = (this.sectionId = v.attr("data-section-id")),
      C = v.attr("data-section-type");
    (this.gridsId = $("#grid-wrapper-" + y)), (this.grids = $(
      "#grid-wrapper-" + y
    )), (this.gridsNamspace = "#grid-wrapper-" + y), this._init();
  }
  return (t.prototype = _.assignIn({}, t.prototype, {
    _init: function() {
      var p = this.sectionId,
        v = (function() {
          function k(R) {
            z.each(function() {
              var Q = $(this);
              Q.data(
                "offsetTop",
                Q.offset().top
              ), R && Q.data("height", Q.height());
            });
          }
          function x() {
            S(z), q.on("debouncedresize", function() {
              (B = 0), (D = -1), k(), I();
              var R = $.data(this, "preview");
              "undefined" != typeof R && P();
            });
          }
          function S(R) {
            R.on("click", "span.og-close", function() {
              return P(), !1;
            })
              .children("a")
              .on("click", function() {
                var N = $(this).parent();
                return E === N.index() ? P() : T(N), !1;
              });
          }
          function I() {
            F = { width: q.width(), height: q.height() };
          }
          function T(R) {
            var Q = $.data(this, "preview"), N = R.data("offsetTop");
            if (((B = 0), "undefined" != typeof Q))
              if (D !== N) N > D && (B = Q.height), P();
              else return Q.update(R), !1;
            (D = N), (Q = $.data(this, "preview", new O(R))), Q.open();
          }
          function P() {
            E = -1;
            var R = $.data(this, "preview");
            R.close(), $.removeData(this, "preview");
          }
          function O(R) {
            (this.$item = R), (this.expandedIdx = this.$item.index()), this.create(), this.update();
          }
          var F,
            A = $("#og-grid-" + p),
            z = A.children("li"),
            E = -1,
            D = -1,
            B = 0,
            V = 10,
            q = $(window),
            U = $("html, body"),
            H = {
              WebkitTransition: "webkitTransitionEnd",
              MozTransition: "transitionend",
              OTransition: "oTransitionEnd",
              msTransition: "MSTransitionEnd",
              transition: "transitionend"
            }[Modernizr.prefixed("transition")],
            M = Modernizr.csstransitions,
            W = { minHeight: 500, speed: 350, easing: "ease" };
          return (O.prototype = {
            create: function() {
              (this.$title = $("<h3></h3>")), (this.$description = $(
                "<p></p>"
              )), (this.$href = $(
                '<a class="button btn1 bshadow alt" href="#"></a>'
              )), (this.$details = $('<div class="og-details"></div>').append(
                this.$title,
                this.$description,
                this.$href
              )), (this.$loading = $(
                '<div class="og-loading"></div>'
              )), (this.$fullimage = $('<div class="og-fullimg"></div>').append(
                this.$loading
              )), (this.$closePreview = $(
                '<span class="og-close"></span>'
              )), (this.$previewInner = $(
                '<div class="og-expander-inner"></div>'
              ).append(
                this.$closePreview,
                this.$fullimage,
                this.$details
              )), (this.$previewEl = $(
                '<div class="og-expander"></div>'
              ).append(this.$previewInner)), this.$item.append(
                this.getEl()
              ), M && this.setTransition();
            },
            update: function(R) {
              if ((R && (this.$item = R), -1 != E)) {
                var Q = z.eq(E);
                Q.removeClass("og-expanded"), this.$item.addClass(
                  "og-expanded"
                ), this.positionPreview();
              }
              E = this.$item.index();
              var N = this.$item.children("a"),
                K = {
                  href: N.attr("href"),
                  largesrc: N.data("largesrc"),
                  title: N.data("title"),
                  cta: N.data("cta"),
                  description: N.data("description")
                };
              this.$title.html(K.title), this.$description.html(
                K.description
              ), this.$href.html("<span>" + K.cta + "</span>"), this.$href.attr(
                "href",
                K.href
              );
              var G = this;
              "undefined" != typeof G.$largeImg &&
                G.$largeImg.remove(), G.$fullimage.is(":visible") &&
                (this.$loading.show(), $("<img/>")
                  .load(function() {
                    var Z = $(this);
                    Z.attr("src") === G.$item.children("a").data("largesrc") &&
                      (G.$loading.hide(), G.$fullimage
                        .find("img")
                        .remove(), (G.$largeImg = Z.fadeIn(
                        350
                      )), G.$fullimage.append(G.$largeImg));
                  })
                  .attr("src", K.largesrc));
            },
            open: function() {
              setTimeout(
                $.proxy(function() {
                  this.setHeights(), this.positionPreview();
                }, this),
                25
              );
            },
            close: function() {
              var R = this,
                Q = function() {
                  M && $(this).off(H), R.$item.removeClass(
                    "og-expanded"
                  ), R.$previewEl.remove();
                };
              return setTimeout(
                $.proxy(function() {
                  "undefined" != typeof this.$largeImg &&
                    this.$largeImg.fadeOut(
                      "fast"
                    ), this.$previewEl.css("height", 0);
                  var N = z.eq(this.expandedIdx);
                  N.css("height", N.data("height")).on(
                    H,
                    Q
                  ), M || Q.call(), setTimeout(function() {
                    N.css("height", "auto");
                  }, 350);
                }, this),
                25
              ), !1;
            },
            calcHeight: function() {
              var R = F.height - this.$item.data("height") - V, Q = F.height;
              R < W.minHeight &&
                ((R = W.minHeight), (Q =
                  W.minHeight +
                  this.$item.data("height") +
                  V)), (this.height = R), (this.itemHeight = Q);
            },
            setHeights: function() {
              var R = this,
                Q = function() {
                  M && R.$item.off(H), R.$item.addClass("og-expanded");
                };
              this.calcHeight(), this.$previewEl.css(
                "height",
                this.height
              ), this.$item.css("height", this.itemHeight).on(H, Q), M ||
                Q.call();
            },
            positionPreview: function() {
              var R = this.$item.data("offsetTop"),
                Q = this.$previewEl.offset().top - B,
                N = this.height + this.$item.data("height") + V <= F.height
                  ? R
                  : this.height < F.height ? Q - (F.height - this.height) : Q;
              U.animate({ scrollTop: N }, W.speed);
            },
            setTransition: function() {
              this.$previewEl.css(
                "transition",
                "height " + W.speed + "ms " + W.easing
              ), this.$item.css(
                "transition",
                "height " + W.speed + "ms " + W.easing
              );
            },
            getEl: function() {
              return this.$previewEl;
            }
          }), {
            init: function(R) {
              (W = $.extend(!0, {}, W, R)), A.imagesLoaded(function() {
                k(!0), I(), x();
              });
            },
            addItems: function(R) {
              (z = z.add(R)), R.each(function() {
                var Q = $(this);
                Q.data({ offsetTop: Q.offset().top, height: Q.height() });
              }), S(R);
            }
          };
        })();
      $(function() {
        v.init();
      });
    },
    onUnload: function() {
      this.$container.off(this.gridsNamspace);
    }
  })), t;
})()), (theme.ProductVariantMobile = (function() {
  function t(p) {
    var v = (this.$container = $(p)),
      y = (this.sectionId = v.attr("data-section-id")),
      C = v.attr("data-section-type");
    (this.wrapperId = $("#" + y)), (this.wrapper = $(
      "#" + y
    )), (this.wrapperNamspace = "#" + y), (this.addCartId = $(
      "#btn-" + y + ".m-allow-cart"
    )), (this.addCartClass = $(
      ".variant-item-" + y + ".m-allow-cart"
    )), this._init();
  }
  return (t.prototype = _.assignIn({}, t.prototype, {
    _init: function() {
      var p = this;
      p._initCompact(), p._initEvents(), $(window).resize(function() {
        767 >= $(window).width() && p._initCompact();
      });
    },
    _initCompact: function() {
      if (0 < $(".product-variant-mobile-section").length) {
        var p = $(".product-variant-mobile-section"),
          v = $(".product-variants-mobile");
        v.each(function() {
          var y = $(this),
            C = y.find(".variants-header"),
            k = C.innerHeight(),
            x = y.find(".variants-content").outerHeight(),
            S = C.closest(".product-variants-mobile");
          C.data("height", k), y.data("height", k + x);
        }), v.each(function() {
          var y = $(this),
            C = y.find(".variants-header"),
            k = C.innerHeight(),
            x = y.find(".variants-content").outerHeight(),
            S = C.closest(".product-variants-mobile");
          C.data(
            "height",
            k
          ), y.data("height", k + x), S.hasClass("active") && S.height(S.data("height"));
        }), p.unbind("click") &&
          p.on("click", ".variants-header .title", function() {
            var y = $(this),
              C = y.closest(".variants-header"),
              k = y.closest(".product-variants-mobile");
            k.hasClass("active") ||
              v
                .closest(".active")
                .removeClass("active")
                .height(
                  y.data("height")
                ), k.toggleClass("active"), k.hasClass("active") ? k.height(k.data("height")) : k.height(C.data("height"));
          });
      }
    },
    _initEvents: function() {
      var p = $("#ProductSelect-product-template.variation-select").val();
      0 < this.addCartId.length &&
        (this.addCartId.unbind("click"), this.addCartId.on("click", function() {
          $("#ProductSelect-product-template.variation-select").val(
            p
          ), $("#AddToCart-product-template").trigger("click");
        })), 0 < this.addCartClass.length &&
        (this.addCartClass.unbind(
          "click"
        ), this.addCartClass.on("click", function() {
          var v = $(this).data("id");
          $("#ProductSelect-product-template.variation-select").val(
            v
          ), $("#AddToCart-product-template").trigger("click");
        }));
    },
    onUnload: function() {
      this.$container.off(this.wrapperNamspace);
    }
  })), t;
})()), $(document).ready(function() {
  var t = new theme.Sections();
  t.register(
    "product-variant-mobile",
    theme.ProductVariantMobile
  ), t.register("grid-view", theme.gridsSection), t.register("collection-template", theme.Filters), t.register("product-template", theme.Product), t.register("mega-menu", theme.MegaMenu), t.register("header-section", theme.HeaderSection), t.register("page-contact-template", theme.Maps), t.register("slideshow-section", theme.SlideshowSection), t.register("product-tabs", theme.ProductTabs), t.register("products", theme.Products), t.register("blog", theme.Blog), t.register("collections", theme.Collections), t.register("footer-section", theme.FooterSection);
}), (window.offcanvas_isopen = !1), (window.offcanvas_close = function() {
  (window.offcanvas_isopen = !1), $("body").removeClass(
    "offcanvas_open offcanvas_left offcanvas_right"
  ), $(
    ".offcanvas_main_content"
  ).one(
    "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
    function() {
      setTimeout(function() {
        $(window).trigger("resize");
      }, 600);
    }
  );
}), (window.offcanvas_open = function(t) {
  !0 == window.offcanvas_isopen &&
    window.offcanvas_close(), (window.offcanvas_isopen = !0), $("body")
    .removeClass("no-offcanvas-animation")
    .addClass("offcanvas_open offcanvas_" + t), $(".nano").nanoScroller({
    iOSNativeScrolling: !0
  });
}), (window.theme = theme || {}), (theme.roarApplication = (function() {
  function t() {
    $(document.body).on("click", '[data-toggle="offcanvas"]', function(ne) {
      ne.preventDefault();
      var le = $(this), de = $("#" + le.data("target")), ce = le.data("src");
      de.length && p(de, ce);
    }), $(
      document.body
    ).on("click", ".offcanvas_overlay, .offcanvas_close", function(ne) {
      ne.preventDefault(), v();
    }), $(document).on("keyup", function(ne) {
      27 == ne.keyCode && v();
    });
  }
  function p(ne, le) {
    $(".offcanvas_target").hide(), $(ne)
      .show()
      .find(".offcanvas_target")
      .show(), $(
      ".offcanvas_aside_right"
    ).one(
      "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
      function() {
        ne.find(".search-field").length &&
          ne
            .find(".search-field")
            .focus()
            .end()
            .off(
              "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"
            );
      }
    ), window.offcanvas_open(le), "left" == le
      ? "sidebar-offcanvas" == ne.attr("id")
          ? $.Velocity.RunSequence([
              {
                e: $(
                  ".offcanvas_sidebars .offcanvas_close, .offcanvas_shop_sidebar"
                ),
                p: { opacity: [1, 0] },
                o: { duration: 300, delay: 0 }
              }
            ])
          : $.Velocity.RunSequence([
              {
                e: $(".offcanvas_mainmenu nav#menu"),
                p: { opacity: [1, 0] },
                o: { duration: 300, delay: 400 }
              },
              {
                e: $(
                  ".offcanvas_mainmenu .offcanvas_close, .language_currency, .mob_inputbox"
                ),
                p: { opacity: [1, 0] },
                o: { duration: 300, delay: 100 }
              },
              {
                e: $(".offcanvas_mainmenu nav#menu .hr-menu-item hr"),
                p: { opacity: [1, 0], width: [50] },
                o: { duration: 300, delay: 100 }
              }
            ])
      : $.Velocity.RunSequence([
          { e: ne, p: { opacity: [1, 0] }, o: { duration: 300, delay: 0 } }
        ]);
  }
  function v() {
    window.offcanvas_close(), $.Velocity.RunSequence([
      {
        e: $(".offcanvas_target"),
        p: { opacity: [0, 1] },
        o: { duration: 300, delay: 200 }
      },
      {
        e: $(".offcanvas_mainmenu nav#menu .hr-menu-item hr"),
        p: { width: [0] },
        o: { duration: 300, delay: 200 }
      }
    ]);
  }
  function y() {
    $(
      document.body
    ).on(
      "focus",
      ".minimal-form-input input, .minimal-form-input textarea, .spr-form input.spr-form-input, .spr-form textarea.spr-form-input",
      function() {
        $(this)
          .closest(".minimal-form-input")
          .addClass("filled")
          .removeClass("no-text"), $(this)
          .closest('div[class^="spr-form-"]')
          .addClass("filled")
          .removeClass("no-text");
      }
    ), $(
      document.body
    ).on(
      "blur",
      '.minimal-form-input input, .minimal-form-input textarea, [class^="spr-form-"] input, [class^="spr-form-"] textarea',
      function() {
        0 < $(this).val().length
          ? ($(this)
              .closest(".minimal-form-input")
              .addClass("has-text")
              .removeClass("no-text"), $(this)
              .closest('div[class^="spr-form-"]')
              .addClass("has-text")
              .removeClass("no-text"))
          : ($(this)
              .closest(".minimal-form-input")
              .removeClass("has-text")
              .addClass("no-text"), $(this)
              .closest('div[class^="spr-form-"]')
              .removeClass("has-text")
              .addClass("no-text")), $(this)
          .closest(".minimal-form-input")
          .removeClass("filled"), $(this)
          .closest('div[class^="spr-form-"]')
          .removeClass("filled");
      }
    );
  }
  function C() {
    "undefined" != typeof SPR &&
      (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
  }
  function k() {
    if (
      ($(".products .product").addClass("eva_ajax_load_more_item_visible"), $(
        document.body
      ).on("click", ".eva_ajax_load_button a", function(le) {
        if ((le.preventDefault(), $(".pagination a.next").length)) {
          $(".eva_ajax_load_button a").attr("data-processing", 1);
          var de = $(".pagination a.next").attr("href"),
            ce = $(".eva_ajax_load_button a").attr("data-loading-items"),
            pe = $(".eva_ajax_load_button a").attr("data-no-more");
          $(".eva_ajax_load_button").hide(), $(".pagination").before(
            '<div class="eva_ajax_load_more_loader animated fadeIn"><a href="#"><i class="icon-px-outline-load"></i>&nbsp;&nbsp;<span>' +
              ce +
              "</span></a></div>"
          ), $.get(de, function(ue) {
            $(".pagination").html(
              $(ue).find(".pagination").html()
            ), $(ue).find(".products .product").each(function() {
              $(this).addClass(
                "hidden"
              ), $(".products .product:last").after($(this)), C(), theme.CurrencyPicker.convert(".products .product:not(.eva_ajax_load_more_item_visible) .money"), te(), se();
            }), $(".eva_ajax_load_more_loader").fadeOut(
              "slow"
            ), $(".eva_ajax_load_button").fadeIn("slow"), $(".eva_ajax_load_button a").attr("data-processing", 0), setTimeout(function() {
              $(".products .product")
                .not(".eva_ajax_load_more_item_visible")
                .addClass("animated fadeIn")
                .one(
                  "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
                  function() {
                    $(this)
                      .removeClass("hidden animated fadeIn")
                      .addClass("eva_ajax_load_more_item_visible");
                  }
                );
            }, 500), 0 == $(".pagination a.next").length &&
              ($(".eva_ajax_load_button")
                .addClass("finished")
                .removeClass("eva_ajax_load_more_hidden"), $(
                ".eva_ajax_load_button a"
              )
                .show()
                .html(pe)
                .addClass("disabled"));
          });
        } else {
          var pe = $(".eva_ajax_load_button a").attr("data-no-more");
          $(".eva_ajax_load_button")
            .addClass("finished")
            .removeClass("eva_ajax_load_more_hidden"), $(
            ".eva_ajax_load_button a"
          )
            .show()
            .html(pe)
            .addClass("disabled");
        }
      }), $(".eva_ajax_load_button").hasClass("eva_ajax_load_more_hidden"))
    ) {
      var ne = Math.abs(0);
      $(window).scroll(function() {
        if ($(".products").length) {
          var le = $(".products").offset().top + $(".products").outerHeight(),
            de = le - $(window).scrollTop();
          de - ne < $(window).height() &&
            0 == $(".eva_ajax_load_button a").attr("data-processing") &&
            $(".eva_ajax_load_button a").trigger("click");
        }
      });
    }
  }
  function I() {
    var ne = $(".list_shop_categories.mobile a"),
      le = $(".list_shop_categories.mobile"),
      de = $(".list_shop_categories.desktop");
    ne.on("click", function(ce) {
      ce.preventDefault(), le.toggleClass("active"), de.toggleClass("active");
    }), $(".catalog-ordering .shop-filter").click(function() {
      $(
        ".offcanvas_mainmenu"
      ).hide(), $(".offcanvas_sidebars").show(), $(".offcanvas_blog_sidebar").hide(), $(".offcanvas_shop_sidebar").show();
    });
  }
  function T() {
    I(), k();
  }
  function P() {
    $.ajax({
      url: "/search",
      beforeSend: function() {
        $(".offcanvas_aside_content .loading-overlay").fadeIn(200), $(
          ".widget_shopping_cart_content"
        )
          .removeClass("blurcontent-off")
          .addClass("blurcontent");
      },
      success: function(ne) {
        var le = '.cart-button [data-toggle="offcanvas"]', de = "#cart_block";
        $(le).html($(ne).find(le).html()), $(de).html(
          $(ne).find(de).html()
        ), theme.CurrencyPicker.convert("#cart_block .money");
      },
      error: function(ne) {
        console.log(ne);
      }
    }).done(function() {
      $(".offcanvas_aside_content .loading-overlay").fadeOut(
        100
      ), $(".offcanvas_minicart .widget_shopping_cart_content").removeClass("blurcontent").addClass("blurcontent-off"), $(".offcanvas_minicart .widget_shopping_cart_content").removeClass("blurcontent-off");
    });
  }
  function O() {
    $(document).on("click", ".add_to_cart_button", function() {
      var ne = $(this), le = ne.closest("form");
      return "" == theme.cart_ajax
        ? (le.submit(), !1)
        : ($.ajax({
            type: "POST",
            url: "/cart/add.js",
            async: !0,
            cache: !1,
            data: le.serialize(),
            dataType: "json",
            beforeSend: function() {
              ne.addClass("loading");
            },
            complete: function() {
              P();
            },
            error: function(de) {
              var ce = $.parseJSON(de.responseText),
                pe = ce.message + ": " + ce.description;
              ne.removeClass("loading"), alert(pe);
            },
            success: function() {}
          }).done(function() {
            B(re, oe), D(), setTimeout(function() {
              $('.cart-button [data-toggle="offcanvas"]').trigger(
                "click"
              ), ne.removeClass("loading");
            }, 500);
          }), !1);
    });
  }
  function A() {
    $(document)
      .on("focus", "#cart_block .update", function() {
        $(this).select();
      })
      .on("blur", "#cart_block .update", function() {
        var ne = $(this), le = ne.val(), de = ne.attr("data-id");
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=" + le + "&id=" + de,
          dataType: "json",
          beforeSend: function() {
            $(".offcanvas_aside_content .loading-overlay").show(), $(
              ".widget_shopping_cart_content"
            )
              .removeClass("blurcontent-off")
              .addClass("blurcontent");
          },
          success: function() {
            P();
          },
          error: function(pe, ue) {
            Shopify.onError(pe, ue);
          }
        });
      });
  }
  function z() {
    $(document).on("click", "#cart_block .remove", function(ne) {
      ne.preventDefault();
      var le = $(this), de = le.attr("data-id");
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + de,
        dataType: "json",
        beforeSend: function() {
          $(".offcanvas_aside_content .loading-overlay").show(), $(
            ".widget_shopping_cart_content"
          )
            .removeClass("blurcontent-off")
            .addClass("blurcontent");
        },
        success: function() {
          P();
        },
        error: function(pe, ue) {
          Shopify.onError(pe, ue);
        }
      });
    });
  }
  function E() {
    var ne = ($(window).width() - $(".cd-quick-view").width()) / 2,
      le = ($(window).height() - $(".cd-quick-view").height()) / 2;
    $(".cd-quick-view").css({ top: le, left: ne });
  }
  function D() {
    0 < $(".compare-preview").length &&
      $(".compare-preview .mfp-close").trigger("click");
  }
  function B(ne, le) {
    var de = $(".cd-close"), ce = $(".empty-box").find("img");
    ce.length &&
      (!$(".cd-quick-view").hasClass("velocity-animating") &&
        $(".cd-quick-view").hasClass("add-content")
        ? V(ce, ne, le, "close")
        : q(ce, ne, le));
  }
  function V(ne, le, de, ce) {
    var pe = ne.closest(".product"),
      ue = ne.offset().top - $(window).scrollTop(),
      ge = ne.offset().left,
      me = ne.width(),
      he = ne.height(),
      fe = $(window).width(),
      ve = $(window).height(),
      _e = (fe - le) / 2,
      ye = 596,
      Ce = (ve - ye) / 2,
      we = 0.8 * fe < de ? 0.8 * fe : de;
    "open" == ce
      ? ($("body").addClass("overlay-layer"), pe.addClass("empty-box"), $(
          ".cd-quick-view"
        )
          .css({ top: ue, left: ge, width: me, height: ye })
          .velocity(
            { top: Ce + "px", left: _e + "px", width: le + "px" },
            1e3,
            [400, 20],
            function() {
              $(".cd-quick-view")
                .addClass("animate-width")
                .velocity(
                  { left: (fe - we) / 2 + "px", width: we + "px" },
                  300,
                  "ease",
                  function() {
                    $(".cd-quick-view").addClass(
                      "add-content"
                    ), (qvSlider = new Swiper(
                      ".cd-quick-view .swiper-container",
                      {
                        pagination: ".swiper-pagination",
                        nextButton: ".swiper-button-next",
                        prevButton: ".swiper-button-prev",
                        preventClick: !0,
                        preventClicksPropagation: !0,
                        grabCursor: !0,
                        onTouchStart: function() {
                          ie = !1;
                        },
                        onTouchMove: function() {
                          ie = !1;
                        },
                        onTouchEnd: function() {
                          setTimeout(function() {
                            ie = !0;
                          }, 300);
                        }
                      }
                    ));
                    var ke = new theme.Sections();
                    ke.register(
                      "product-quickview-template",
                      theme.Product
                    ), theme.CurrencyPicker.convert(
                      "#ProductSection-product-quickview-template .money"
                    );
                  }
                );
            }
          )
          .addClass("is-visible"))
      : $(".cd-quick-view")
          .removeClass("add-content")
          .velocity(
            { top: Ce + "px", left: _e + "px", width: le + "px" },
            300,
            "ease",
            function() {
              $("body").removeClass("overlay-layer"), $(".cd-quick-view")
                .removeClass("animate-width")
                .velocity(
                  { top: ue, left: ge, width: me },
                  500,
                  "ease",
                  function() {
                    $(".cd-quick-view").removeClass(
                      "is-visible"
                    ), pe.removeClass("empty-box");
                  }
                );
            }
          );
  }
  function q(ne) {
    var ce = ne.closest(".product"),
      pe = ne.offset().top - $(window).scrollTop(),
      ue = ne.offset().left,
      ge = ne.width();
    $("body").removeClass("overlay-layer"), ce.removeClass("empty-box"), $(
      ".cd-quick-view"
    )
      .velocity("stop")
      .removeClass("add-content animate-width is-visible")
      .css({ top: pe, left: ue, width: ge });
  }
  function F() {
    $(document).on("click", ".eva_product_quick_view_button", function(ne) {
      ne.preventDefault();
      var le = $(this);
      le.closest(".product").find(".product_thumbnail").addClass("loading");
      var de = $(this).data("product_id"),
        ce = $(this).closest(".product").find(".product_thumbnail img");
      $.ajax({
        url: "/products/" + de + "?view=quickview",
        success: function(pe) {
          $(".cd-quick-view").empty().html(pe), V(ce, re, oe, "open");
        },
        error: function(pe) {
          console.log(pe);
        }
      }).done(function() {
        le.parent().find(".product_thumbnail").removeClass("loading");
      });
    });
  }
  function U() {
    O(), z(), A(), F();
  }
  function L() {
    $(".format-gallery-swiper").each(function() {
      var ce = $(this),
        pe = new Swiper(this, {
          speed: 300,
          centeredSlides: !0,
          mode: "horizontal",
          loop: !0,
          slidesPerView: 1,
          paginationClickable: !0,
          pagination: ".pagination",
          grabCursor: !0,
          nextButton: ce.find(".swiper-button-next")[0],
          prevButton: ce.find(".swiper-button-prev")[0],
          onSwiperCreated: (function(ue) {
            setTimeout(function() {
              ue
                .closest(".gallery-slider-wrapper")
                .css(
                  "visibility",
                  "visible"
                ), ue.closest(".gallery-slider-wrapper").css("opacity", "1");
            }, 300);
          })(ce),
          onInit: function() {},
          onSlideChangeEnd: function() {},
          paginationBulletRender: function(ue, ge, me) {
            return '<div class="' + me + '"><span></span></div>';
          }
        });
    });
  }
  function H() {
    var le = [
      {},
      {
        movement: {
          imgWrapper: {
            translation: { x: 10, y: 10, z: 30 },
            rotation: { x: 0, y: -10, z: 0 },
            reverseAnimation: { duration: 200, easing: "easeOutQuad" }
          },
          lines: {
            translation: { x: 10, y: 10, z: [0, 70] },
            rotation: { x: 0, y: 0, z: -2 },
            reverseAnimation: { duration: 2e3, easing: "easeOutExpo" }
          },
          caption: {
            rotation: { x: 0, y: 0, z: 2 },
            reverseAnimation: { duration: 200, easing: "easeOutQuad" }
          },
          overlay: {
            translation: { x: 10, y: -10, z: 0 },
            rotation: { x: 0, y: 0, z: 2 },
            reverseAnimation: { duration: 2e3, easing: "easeOutExpo" }
          },
          shine: {
            translation: { x: 100, y: 100, z: 0 },
            reverseAnimation: { duration: 200, easing: "easeOutQuad" }
          }
        }
      },
      {
        movement: {
          imgWrapper: {
            rotation: { x: -5, y: 10, z: 0 },
            reverseAnimation: { duration: 900, easing: "easeOutCubic" }
          },
          caption: {
            translation: { x: 30, y: 30, z: [0, 40] },
            rotation: { x: [0, 15], y: 0, z: 0 },
            reverseAnimation: { duration: 1200, easing: "easeOutExpo" }
          },
          overlay: {
            translation: { x: 10, y: 10, z: [0, 20] },
            reverseAnimation: { duration: 1e3, easing: "easeOutExpo" }
          },
          shine: {
            translation: { x: 100, y: 100, z: 0 },
            reverseAnimation: { duration: 900, easing: "easeOutCubic" }
          }
        }
      },
      {
        movement: {
          imgWrapper: {
            rotation: { x: -5, y: 10, z: 0 },
            reverseAnimation: { duration: 50, easing: "easeOutQuad" }
          },
          caption: {
            translation: { x: 20, y: 20, z: 0 },
            reverseAnimation: { duration: 200, easing: "easeOutQuad" }
          },
          overlay: {
            translation: { x: 5, y: -5, z: 0 },
            rotation: { x: 0, y: 0, z: 6 },
            reverseAnimation: { duration: 1e3, easing: "easeOutQuad" }
          },
          shine: {
            translation: { x: 50, y: 50, z: 0 },
            reverseAnimation: { duration: 50, easing: "easeOutQuad" }
          }
        }
      },
      {
        movement: {
          imgWrapper: {
            translation: { x: 0, y: -8, z: 0 },
            rotation: { x: 3, y: 3, z: 0 },
            reverseAnimation: { duration: 1200, easing: "easeOutExpo" }
          },
          lines: {
            translation: { x: 15, y: 15, z: [0, 15] },
            reverseAnimation: { duration: 1200, easing: "easeOutExpo" }
          },
          overlay: {
            translation: { x: 0, y: 8, z: 0 },
            reverseAnimation: { duration: 600, easing: "easeOutExpo" }
          },
          caption: {
            translation: { x: 10, y: -15, z: 0 },
            reverseAnimation: { duration: 900, easing: "easeOutExpo" }
          },
          shine: {
            translation: { x: 50, y: 50, z: 0 },
            reverseAnimation: { duration: 1200, easing: "easeOutExpo" }
          }
        }
      },
      {
        movement: {
          lines: {
            translation: { x: -5, y: 5, z: 0 },
            reverseAnimation: { duration: 1e3, easing: "easeOutExpo" }
          },
          caption: {
            translation: { x: 15, y: 15, z: 0 },
            rotation: { x: 0, y: 0, z: 3 },
            reverseAnimation: {
              duration: 1500,
              easing: "easeOutElastic",
              elasticity: 700
            }
          },
          overlay: {
            translation: { x: 15, y: -15, z: 0 },
            reverseAnimation: { duration: 500, easing: "easeOutExpo" }
          },
          shine: {
            translation: { x: 50, y: 50, z: 0 },
            reverseAnimation: { duration: 500, easing: "easeOutExpo" }
          }
        }
      },
      {
        movement: {
          imgWrapper: {
            translation: { x: 5, y: 5, z: 0 },
            reverseAnimation: { duration: 800, easing: "easeOutQuart" }
          },
          caption: {
            translation: { x: 10, y: 10, z: [0, 50] },
            reverseAnimation: { duration: 1e3, easing: "easeOutQuart" }
          },
          shine: {
            translation: { x: 50, y: 50, z: 0 },
            reverseAnimation: { duration: 800, easing: "easeOutQuart" }
          }
        }
      },
      {
        movement: {
          lines: {
            translation: { x: 40, y: 40, z: 0 },
            reverseAnimation: { duration: 1500, easing: "easeOutElastic" }
          },
          caption: {
            translation: { x: 20, y: 20, z: 0 },
            rotation: { x: 0, y: 0, z: -5 },
            reverseAnimation: { duration: 1e3, easing: "easeOutExpo" }
          },
          overlay: {
            translation: { x: -30, y: -30, z: 0 },
            rotation: { x: 0, y: 0, z: 3 },
            reverseAnimation: { duration: 750, easing: "easeOutExpo" }
          },
          shine: {
            translation: { x: 100, y: 100, z: 0 },
            reverseAnimation: { duration: 750, easing: "easeOutExpo" }
          }
        }
      }
    ];
    (function() {
      var de = 0;
      [].slice
        .call(document.querySelectorAll(".tilter"))
        .forEach(function(ce, pe) {
          (de = 0 == pe % 30 ? de + 1 : de), new TiltFx(ce, le[de - 1]);
        });
    })();
  }
  function M() {
    $(document).on("click", ".add_to_wishlist:not(.added)", function(ne) {
      if (!$(this).hasClass("need-login")) {
        ne.preventDefault();
        var le = $(this),
          de = le.closest("form"),
          ce = { action: "add_wishlist" };
        return (ce = de.serialize() + "&" + $.param(ce)), $.ajax({
          type: "POST",
          url: "/a/wishlist",
          async: !0,
          cache: !1,
          data: ce,
          dataType: "json",
          beforeSend: function() {
            le.hasClass("tooltip")
              ? le.addClass("loading")
              : le
                  .attr("title", le.attr("data-loading-text"))
                  .find("span")
                  .text(le.attr("data-loading-text"));
          },
          error: function(pe) {
            console.log(pe);
          },
          success: function(pe) {
            le.hasClass("tooltip") && le.removeClass("loading");
            var ue = $(".wishlist" + le.prev().val());
            1 == pe.code
              ? (ue
                  .attr("title", le.attr("data-added"))
                  .addClass("added")
                  .find("span")
                  .text(le.attr("data-added")), $(
                  ".wishlist_items_number"
                ).text(pe.json))
              : (ue
                  .attr("title", le.attr("data-title"))
                  .find("span")
                  .text(le.attr("data-title")), alert(pe.json));
          }
        }), !1;
      }
    });
  }
  function W() {
    $(document).on("click", ".remove_from_wishlist", function(ne) {
      ne.preventDefault();
      var le = $(this),
        de = le.closest("form"),
        ce = { action: "remove_wishlist" };
      return (ce = de.serialize() + "&" + $.param(ce)), $.ajax({
        type: "POST",
        url: "/a/wishlist",
        async: !0,
        cache: !1,
        data: ce,
        dataType: "json",
        beforeSend: function() {
          $(".page-wishlist").addClass("loading");
        },
        error: function(pe) {
          console.log(pe), $(".page-wishlist").removeClass("loading");
        },
        success: function(pe) {
          1 == pe.code
            ? le.closest("tr").slideUp("fast", function() {
                le
                  .closest("tr")
                  .remove(), $(".page-wishlist .infos").removeClass("hide"), $(".wishlist_items_number").text(pe.json), 0 == pe.json && $(".wishlist-empty").removeClass("hide");
              })
            : alert(pe.json), $(".page-wishlist").removeClass("loading");
        }
      }), !1;
    });
  }
  function R() {
    $(".blog-content-area, .content-area").fitVids();
  }
  function Q() {
    var ne = $(".box-share-master-container").attr("data-share-elem");
    $(".social-sharing").socialShare({
      social: ne,
      animation: "launchpadReverse",
      blur: !0
    });
  }
  function N() {
    $(".toggle_simple .toggle_title").on("click", function() {
      var ne = $(this),
        le = ne.closest(".toggle_simple"),
        de = le.find(".toggle_content");
      de.slideToggle(function() {
        le.toggleClass("toggle_active"), $(window).trigger("resize");
      });
    });
  }
  function K() {
    if ($("#popup-mailchimp").length) {
      function de() {
        $(document.body).removeClass("modal-open");
        var ce = $(".popup-modal.open");
        ce.fadeOut(function() {
          $(this).removeClass("open");
        }), $(document.body).trigger("roar_modal_closed", [ce]);
      }
      var ne = parseInt(theme.popup_mailchimp_period),
        le = parseInt(theme.popup_mailchimp_delay);
      if (
        0 < ne && document.cookie.match(/^(.*;)?\s*eva_popup\s*=\s*[^;]+(.*)?$/)
      )
        return;
      (le = Math.max(le, 0)), $(window).on("load", function() {
        setTimeout(function() {
          $(document.body).addClass(
            "modal-open"
          ), $(".popup-modal").fadeIn(), $(".popup-modal").addClass("open");
        }, 1e3 * le);
      }), $(document.body).on("roar_modal_closed", function(ce, pe) {
        if (pe.hasClass("roar-popup")) {
          var ue = new Date(), ge = ue.getTime();
          ue.setTime(
            ue.getTime() + 1e3 * (60 * (60 * (24 * ne)))
          ), (document.cookie =
            "eva_popup=" + ge + ";expires=" + ue.toGMTString() + ";path=/");
        }
      }), $(
        document.body
      ).on("click", ".close-modal, .popup-backdrop", function(ce) {
        ce.preventDefault(), de();
      }), $(document).on("keyup", function(ce) {
        27 === ce.keyCode && de();
      });
    }
  }
  function G() {
    $(window).on("load", function() {
      "undefined" != typeof window.notifySettings &&
        ((notifyProIO.settings = {}), (notifyProIO.settings.message =
          window.notifySettings.message), (notifyProIO.settings.hideMobile = !0), (notifyProIO.settings.initialDelay = 3e3), (notifyProIO.settings.displayInterval =
          window.notifySettings.displayInterval), (notifyProIO.settings.displayHold =
          window.notifySettings.displayHold), (notifyProIO.settings.totalPerPage =
          window.notifySettings.totalPerPage), (notifyProIO.settings.totalDisplayed = 0), (notifyProIO.settings.loop = !0), notifyProIO.setup(
          window.notifyProducts
        ));
    });
  }
  function Z() {
    return document.cookie.match(/^(.*;)?\s*eva_cookie\s*=\s*[^;]+(.*)?$/)
      ? void $(".cc_container").remove()
      : void ($(window).on("load", function() {
          setTimeout(function() {
            $(".cc_container").addClass("open");
          }, 5e3);
        }), $(".cc_btn").click(function(ne) {
          ne.preventDefault();
          var le = new Date(), de = le.getTime();
          le.setTime(
            le.getTime() + 31536000000
          ), (document.cookie = "eva_cookie=" + de + ";expires=" + le.toGMTString() + ";path=/"), $(".cc_container").removeClass("open");
        }));
  }
  function Y() {
    function le(he, fe, ve) {
      var _e = he + "=" + encodeURIComponent(fe);
      if (ve) {
        var ye = new Date();
        ye.setTime(ye.getTime() + 1e3 * (60 * (60 * (24 * ve)))), (_e +=
          ";expires=" + ye.toGMTString());
      }
      (_e += ";path=/"), (document.cookie = _e);
    }
    function de() {
      pe.hasClass("open")
        ? (pe.removeClass("open"), le("eva-fbchat", "0", 365))
        : (pe.addClass("open"), ce(), le("eva-fbchat", "1", 365));
    }
    function ce() {
      var he = $(".fb-sheet-content-inner"),
        fe = he.width(),
        ve = he.height(),
        _e = he.attr("data-timeline"),
        ye = he.attr("data-events"),
        Ce = he.attr("data-page");
      ge.html(
        '<div class="fb-page" data-tabs="messages' +
          ("true" == _e && ", timeline") +
          ("true" == ye && ", events") +
          '" data-width="' +
          fe +
          '" data-height="' +
          ve +
          '" data-href="' +
          Ce +
          '" data-small-header="true"  data-hide-cover="false" data-show-facepile="true" data-adapt-container-width="false"><div class="fb-xfbml-parse-ignore"><blockquote>Loading...</blockquote></div></div>'
      ), "FB" in window && FB.XFBML.parse();
    }
    var pe = $(".fb-sheet"),
      ue = $(".fb-sheet-content"),
      ge = $(".fb-sheet-content-part");
    $(".fbchat-badge").click(function() {
      return de(), !1;
    }), $(".fb-sheet-head-close").click(function() {
      return de(), !1;
    }), "1" ==
      (function(he) {
        return (
          (he = (document.cookie.match("(^|; )" + he + "=([^;]*)") || 0)[2]) &&
          decodeURIComponent(he)
        );
      })("eva-fbchat")
      ? (pe.addClass("open"), ce())
      : pe.removeClass("open");
    var me = (function() {
      var he = {};
      return function(fe, ve, _e) {
        _e || (_e = "Don't call this twice without a uniqueId"), he[_e] &&
          clearTimeout(he[_e]), (he[_e] = setTimeout(fe, ve));
      };
    })();
    $(window).resize(function() {
      ge.html('<div class="fb-spin"></div>'), me(
        function() {
          ce();
        },
        500,
        "some unique string"
      );
    });
  }
  function J() {
    jQuery("#be_compare_features_table").on("scroll", function() {
      var ne = jQuery(this).parent();
      jQuery(this).scrollLeft() + jQuery(this).innerWidth() >=
        jQuery(this)[0].scrollWidth
        ? ne.hasClass("scroll-right") && ne.removeClass("scroll-right")
        : 0 === jQuery(this).scrollLeft()
            ? ne.hasClass("scroll-left") && ne.removeClass("scroll-left")
            : (!ne.hasClass("scroll-right") &&
                ne.addClass("scroll-right"), !ne.hasClass("scroll-left") &&
                ne.addClass("scroll-left"));
    }), (be_compare_container = document.getElementById(
      "be_compare_features_table"
    )), null !== be_compare_container &&
      be_compare_container.offsetWidth < be_compare_container.scrollWidth &&
      !jQuery("#be_compare_features_table_inner").hasClass("scroll-right") &&
      jQuery("#be_compare_features_table_inner").addClass(
        "scroll-right"
      ), jQuery(window).on("resize", function() {
      X();
    }), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") ||
      jQuery("#be_compare_features_table_inner").hasClass("scroll-right")
      ? $(".compare-preview").addClass("no-flex")
      : $(".compare-preview").removeClass("no-flex");
  }
  function X() {
    be_compare_container = document.getElementById("be_compare_features_table");
    null === be_compare_container ||
      (be_compare_container.offsetWidth < be_compare_container.scrollWidth
        ? !jQuery("#be_compare_features_table_inner").hasClass(
            "scroll-right"
          ) &&
            jQuery("#be_compare_features_table_inner").addClass("scroll-right")
        : (jQuery("#be_compare_features_table_inner").hasClass(
            "scroll-right"
          ) &&
            jQuery("#be_compare_features_table_inner").removeClass(
              "scroll-right"
            ), jQuery("#be_compare_features_table_inner").hasClass(
            "scroll-left"
          ) &&
            jQuery("#be_compare_features_table_inner").removeClass(
              "scroll-left"
            )), jQuery("#be_compare_features_table_inner").hasClass(
        "scroll-left"
      ) || jQuery("#be_compare_features_table_inner").hasClass("scroll-right")
        ? $(".compare-preview").addClass("no-flex")
        : $(".compare-preview").removeClass("no-flex"));
  }
  function ee() {
    var ne = $("body"), le = $("a.add_to_compare"), de = "", pe = !1;
    ne.on("click", "a.add_to_compare", function() {
      var ue = $(this),
        ge = ue.data("pid"),
        me = Currency.cookie.rtread("rt-compare"),
        he = !1;
      if (
        ((pe = !1), ue
          .closest(".product")
          .find(".product_thumbnail")
          .addClass("loading"), (me = null != me && "" != me
          ? me.split(",")
          : []), ue.hasClass("reach-limit") &&
          ((pe = !0), !1 === $(this).hasClass("added") &&
            ((he = !0), jQuery("#rtp-message").html(
              theme.strings.c_msg
            ), jQuery("#rt-unero-popup-message")
              .css(
                "margin-left",
                "-" +
                  parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 +
                  "px"
              )
              .fadeIn(), window.setTimeout(function() {
              jQuery("#rt-unero-popup-message").fadeOut();
            }, 2e3))), 0 > me.indexOf(ge) &&
          !1 === $(this).hasClass("added") &&
          !1 == pe)
      ) {
        me.push(ge);
        var fe = me.join(",");
        "," == fe.substring(0, 1) &&
          (fe = fe.substring(1)), Currency.cookie.rtwrite("rt-compare", fe);
      }
      !1 === $(this).hasClass("added") || "" == de
        ? ((de = ""), $.ajax({
            url: "/pages/compare/" + me,
            dataType: "html",
            type: "GET",
            success: function(ve) {
              de = ve;
            },
            error: function() {
              console.log("ajax error"), ue
                .closest(".product")
                .find(".product_thumbnail")
                .removeClass("loading");
            },
            complete: function() {
              me.length >= parseInt(theme.compare_limit) &&
                0 < $("a.add_to_compare").length &&
                $("a.add_to_compare").each(function() {
                  $(this).addClass("reach-limit");
                }), $.magnificPopup.open({
                items: { src: de, type: "inline" },
                preloader: !0,
                tLoading: "",
                mainClass: "compare-preview",
                removalDelay: 200,
                gallery: { enabled: !0 },
                callbacks: {
                  open: function() {
                    !1 == he &&
                      ($('[data-pid="' + ge + '"]')
                        .addClass("added")
                        .attr(
                          "data-original-title",
                          $('[data-pid="' + ge + '"]').attr("data-added")
                        ), $('[data-pid="' + ge + '"]').hasClass(
                        "eva_product_compare_button"
                      )
                        ? $('[data-pid="' + ge + '"]').html(
                            $('[data-pid="' + ge + '"]').attr("data-added")
                          )
                        : $('[data-pid="' + ge + '"]')
                            .find("span")
                            .html(
                              $('[data-pid="' + ge + '"]').attr("data-added")
                            )), ue
                      .closest(".product")
                      .find(".product_thumbnail")
                      .removeClass("loading"), theme.CurrencyPicker.convert(
                      ".compare-content .money"
                    ), C(), J();
                  }
                }
              });
            }
          }))
        : $.ajax({
            url: "/pages/compare/" + me,
            dataType: "html",
            type: "GET",
            success: function(ve) {
              de = ve;
            },
            error: function() {
              console.log("ajax error"), ue
                .closest(".product")
                .find(".product_thumbnail")
                .removeClass("loading");
            },
            complete: function() {
              $.magnificPopup.open({
                items: { src: de, type: "inline" },
                preloader: !0,
                tLoading: "",
                mainClass: "compare-preview",
                removalDelay: 200,
                gallery: { enabled: !0 },
                callbacks: {
                  open: function() {
                    ue
                      .closest(".product")
                      .find(".product_thumbnail")
                      .removeClass("loading"), theme.CurrencyPicker.convert(
                      ".compare-content .money"
                    ), C(), J();
                  }
                }
              });
            }
          });
    }), ne.on("click", ".remove_from_compare", function(ue) {
      ue.preventDefault();
      var ge = $(this), me = ge.attr("data-rev"), he = $(".compare-content");
      $('[data-pid="' + me + '"]')
        .removeClass("added")
        .attr(
          "data-original-title",
          $('[data-pid="' + me + '"]').attr("data-title")
        ), $('[data-pid="' + me + '"]').find("span").html($('[data-pid="' + me + '"]').attr("data-title"));
      var fe = decodeURI(Currency.cookie.rtread("rt-compare"));
      null != fe &&
        ((fe = fe.split(",")), fe.length <= theme.compare_limit &&
          0 < $("a.add_to_compare").length &&
          $("a.add_to_compare").each(function() {
            $(this).removeClass("reach-limit");
          })), (fe = jQuery.grep(fe, function(ve) {
        return ve != me;
      })), (fe = $.trim(
        fe
      )), Currency.cookie.rtwrite("rt-compare", fe), J(), $(".unero_" + me).remove(), 0 >= fe.length && $(".mfp-close").trigger("click");
    });
  }
  function te() {
    if (0 != parseInt(theme.compare)) {
      var ne = Currency.cookie.rtread("rt-compare");
      null == ne
        ? (ne = [])
        : ((ne = ne.split(",")), ne.length >= parseInt(theme.compare_limit) &&
            $(".add_to_compare").addClass("reach-limit"), ne.map(function(le) {
            $('[data-pid="' + le + '"]')
              .addClass("added")
              .attr(
                "data-original-title",
                $('[data-pid="' + le + '"]').attr("data-added")
              ), $('[data-pid="' + le + '"]').hasClass("eva_product_compare_button") ? $('[data-pid="' + le + '"]').html($('[data-pid="' + le + '"]').attr("data-added")) : $('[data-pid="' + le + '"]').find("span").html($('[data-pid="' + le + '"]').attr("data-added"));
          }));
    }
  }
  function ae() {
    "1" == theme.compare && (ee(), te(), J());
  }
  function se() {
    $().countdown &&
      0 < $(".countdown-item").length &&
      $(".countdown-item").each(function() {
        if (!$(this).hasClass("is-countdown")) {
          var ne = new Date(),
            le = $(this).data("countdown").split("-"),
            le = new Date(le[2], parseInt(le[0]) - 1, le[1]);
          ne < le &&
            $(this).countdown({
              until: le,
              layout: "<div><i>{dn}</i><span>{dl}</span></div><div><i>{hn}</i><span>{hl}</span></div><div><i>{mn}</i><span>{ml}</span></div><div><i>{sn}</i><span>{sl}</span></div>"
            });
        }
      });
  }
  $("body").on("click", function(ne) {
    ($(ne.target).is(".cd-close") || $(ne.target).is("body.overlay-layer")) &&
      !0 == ie &&
      (ne.preventDefault(), B(re, oe));
  }), $(document).keyup(function(ne) {
    "27" == ne.which && B(re, oe);
  }), $(window).on("resize", function() {
    $(".cd-quick-view").hasClass("is-visible") &&
      window.requestAnimationFrame(E);
  });
  var re = 480, oe = 960, ie = !0;
  return {
    init: function() {
      t(), y(), T(), U(), L(), H(), M(), W(), R(), N(), Q(), K(), G(), Z(), Y(), ae(), se();
    }
  };
})()), (theme.init = function() {
  theme.roarApplication.init(), theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus(
    $(window.location.hash)
  ), $(".in-page-link").on("click", function(t) {
    slate.a11y.pageLinkFocus($(t.currentTarget.hash));
  }), $('a[href="#"]').on("click", function(t) {
    t.preventDefault();
  });
});
try {
  $(theme.init);
} finally {
  setTimeout(function() {
    $("body").addClass("loaded");
  }, 2e3);
}
